export const LEADERBOARD_MOSTWINS_1DAY = {
  status: 200,
  body: {
    status: 200,
    msg: 'Leaderboard',
    data: {
      lastUpdated: 1741611608459,
      leaderboardData: {
        '0ANFbHbkKXgv2ss6NJ1oLB5jxli2': {
          nick: 'Woo',
          operatorId: 'THNDR',
          position: 86,
          rank: 61,
          value: 1,
        },
        '1990c411-0090-4779-abe9-f76c9ef06943': {
          nick: 'Duncan Rushing',
          operatorId: 'speed',
          position: 76,
          rank: 61,
          value: 1,
        },
        '2UXKtKldCtUSajNQMrr0Em5hvfR2': {
          nick: 'Dat Nguyen',
          operatorId: 'THNDR',
          position: 39,
          rank: 39,
          value: 2,
        },
        '2b1c7f73-b210-47ef-8152-ac1810a8d490': {
          nick: 'Laura Hopstaken',
          operatorId: 'speed',
          position: 99,
          rank: 61,
          value: 1,
        },
        '2eb3ca69-4b96-4f6c-9b35-7657d263a419': {
          nick: 'p00kiebaby',
          operatorId: 'telegram',
          position: 85,
          rank: 61,
          value: 1,
        },
        '2f9ccb6c-fea1-46c4-bcb3-0214c4abaf04': {
          nick: 'chessfan777',
          operatorId: 'betopenly',
          position: 16,
          rank: 16,
          value: 7,
        },
        '3250050e-ad3a-4d06-b779-bcc1b532dfe0': {
          nick: 'PazZayy',
          operatorId: 'telegram',
          position: 26,
          rank: 25,
          value: 4,
        },
        '35044969-6f82-4ea6-8773-fbeee4c03544': {
          nick: 'Shahryar Eslami Moghaddam',
          operatorId: 'speed',
          position: 82,
          rank: 61,
          value: 1,
        },
        '42280e00-0e2d-41a9-aaac-05e9c0b84826': {
          nick: 'Passiveuro',
          operatorId: 'telegram',
          position: 59,
          rank: 39,
          value: 2,
        },
        '42f20c5c-c75a-4515-97c0-98ba62487d26': {
          nick: 'Tracey Morrison',
          operatorId: 'speed',
          position: 48,
          rank: 39,
          value: 2,
        },
        '46938e4c-bc24-45cd-9b93-460eef349086': {
          nick: 'Neshdan',
          operatorId: 'telegram',
          position: 13,
          rank: 12,
          value: 8,
        },
        '46PjSe8BRbUKqhUFefslwGWDTzI2': {
          nick: 'ChickieDee',
          operatorId: 'THNDR',
          position: 74,
          rank: 61,
          value: 1,
        },
        '471ed25d-5f49-43fa-8168-dc60aca5bb0a': {
          nick: 'Brokk Beam',
          operatorId: 'speed',
          position: 65,
          rank: 61,
          value: 1,
        },
        '4I7HWcHGprVlEzbKOdrxCKAp49x1': {
          nick: 'Kendrab23',
          operatorId: 'THNDR',
          position: 23,
          rank: 21,
          value: 5,
        },
        '4W29W8plWNgZb3jFon56OFgNSHJ3': {
          nick: 'suckmydiesel',
          operatorId: 'THNDR',
          position: 79,
          rank: 61,
          value: 1,
        },
        '4aa0ed64-17d4-42ac-80dc-9276c6b261e5': {
          nick: 'James Ferrell',
          operatorId: 'speed',
          position: 33,
          rank: 33,
          value: 3,
        },
        '5QfuKqzJ77cjIzIMpbirJPKig8w2': {
          nick: 'BtceXMasteR',
          operatorId: 'THNDR',
          position: 6,
          rank: 6,
          value: 16,
        },
        '5d54f9d2-e7d6-41f7-a60d-4469af688ef3': {
          nick: 'Samuel Yilak',
          operatorId: 'speed',
          position: 97,
          rank: 61,
          value: 1,
        },
        '5sFdUGZOOnZEDRkw2WXAeBXdsmF2': {
          nick: 'savinghumanity',
          operatorId: 'THNDR',
          position: 72,
          rank: 61,
          value: 1,
        },
        '699f6481-94c1-4a51-9680-c3b18abcac8c': {
          nick: 'Airavat01',
          operatorId: 'telegram',
          position: 83,
          rank: 61,
          value: 1,
        },
        '6f9538d7-19ff-427d-b910-070f347f5785': {
          nick: 'Paul Sedov',
          operatorId: 'speed',
          position: 54,
          rank: 39,
          value: 2,
        },
        '71fcc902-113d-4a36-8f6d-3b7e9f84d50c': {
          nick: 'OmarCripto86',
          operatorId: 'telegram',
          position: 5,
          rank: 4,
          value: 17,
        },
        '754a6395-04f9-4d0d-a9fc-4cef356edae3': {
          nick: 'lukep2002',
          operatorId: 'betopenly',
          position: 36,
          rank: 33,
          value: 3,
        },
        '86c32412-7374-49d1-a9d7-0ecfb4630127': {
          nick: 'Dheyaisgavidia',
          operatorId: 'telegram',
          position: 24,
          rank: 21,
          value: 5,
        },
        '877628a5-7dae-445b-b698-567459c035a9': {
          nick: 'Kevin Zuhaus',
          operatorId: 'speed',
          position: 95,
          rank: 61,
          value: 1,
        },
        '892383d9-10e4-40bd-bdda-922b296f9bec': {
          nick: 'Kody Laurent',
          operatorId: 'speed',
          position: 20,
          rank: 18,
          value: 6,
        },
        '8Jdg8uC8SGP0T5divdQe1WxPobN2': {
          nick: 'sanyeo',
          operatorId: 'THNDR',
          position: 73,
          rank: 61,
          value: 1,
        },
        '8a70ecfe-7dd7-47c9-bc63-d9a38f3dc7ed': {
          nick: 'JeyG Gluch',
          operatorId: 'speed',
          position: 43,
          rank: 39,
          value: 2,
        },
        '980098ad-a54b-49d9-8717-13926a770425': {
          nick: 'William Hecimovich',
          operatorId: 'speed',
          position: 60,
          rank: 39,
          value: 2,
        },
        '9Y7FojpTt0XkYW1RoufrOvV2sgI2': {
          nick: 'quite ',
          operatorId: 'THNDR',
          position: 41,
          rank: 39,
          value: 2,
        },
        '9oPTDONwyvXcifEZO2BJG9rbZeP2': {
          nick: 'serberuz',
          operatorId: 'THNDR',
          position: 15,
          rank: 12,
          value: 8,
        },
        A8OIhvNl2eV87S7o8RmrOOr2eLl2: {
          nick: 'DabroX',
          operatorId: 'THNDR',
          position: 22,
          rank: 21,
          value: 5,
        },
        AR1fJqJZqLSHFt9UtBQELu9J2C42: {
          nick: 'GA99Y',
          operatorId: 'THNDR',
          position: 11,
          rank: 11,
          value: 9,
        },
        AS7GV1EVBDQayArH5bPzaAXfMSs1: {
          nick: 'larame413',
          operatorId: 'THNDR',
          position: 52,
          rank: 39,
          value: 2,
        },
        B7W0BEKPOFfKcyuxHBO4S2tNqIU2: {
          nick: 'RuegoOhYXZqqh7',
          operatorId: 'THNDR',
          position: 30,
          rank: 25,
          value: 4,
        },
        BIMH6yaAn7NapBRCl03x7na5Ji73: {
          nick: 'random39',
          operatorId: 'THNDR',
          position: 84,
          rank: 61,
          value: 1,
        },
        BUPhdpHpquSC3I3EPnRiisQHAhh1: {
          nick: 'thomsolodev',
          operatorId: 'THNDR',
          position: 32,
          rank: 25,
          value: 4,
        },
        DqOwlFWF9pgD6V3Rf2iZH8SYhW02: {
          nick: 'boby',
          operatorId: 'THNDR',
          position: 89,
          rank: 61,
          value: 1,
        },
        DquvTqsjUWhHmfwDxweisAaVbSs1: {
          nick: 'Jason B',
          operatorId: 'THNDR',
          position: 29,
          rank: 25,
          value: 4,
        },
        DuTSHjO8XrZBLxkoPt6v6x6Xp9n1: {
          nick: '1ll',
          operatorId: 'THNDR',
          position: 47,
          rank: 39,
          value: 2,
        },
        E3PPyFdgU2cCYUQ02Gk35OHSHbo2: {
          nick: 'richmondtina',
          operatorId: 'THNDR',
          position: 10,
          rank: 10,
          value: 10,
        },
        EH28THF8y1gU8fM89ykJJkmYP9T2: {
          nick: 'Rexdentron',
          operatorId: 'THNDR',
          position: 8,
          rank: 8,
          value: 12,
        },
        Em3mJ9Y8ePdPLtQZnJ6prqAWxWf2: {
          nick: 'lala ',
          operatorId: 'THNDR',
          position: 40,
          rank: 39,
          value: 2,
        },
        J9krVBUj4zdkwNDqPWv913KMsFY2: {
          nick: 'jahdidit',
          operatorId: 'THNDR',
          position: 51,
          rank: 39,
          value: 2,
        },
        JqiNCGXjkaMqEYFPOYCaW0qcYfl1: {
          nick: 'privateprinzesska',
          operatorId: 'THNDR',
          position: 55,
          rank: 39,
          value: 2,
        },
        MqL8KlOXGNajWFThPljAFpLiipX2: {
          nick: 'Running',
          operatorId: 'THNDR',
          position: 17,
          rank: 16,
          value: 7,
        },
        NVaHlioPCZM4HqkMbPIO9MufcGN2: {
          nick: 'jas0615',
          operatorId: 'THNDR',
          position: 81,
          rank: 61,
          value: 1,
        },
        PSc4nkg5E8MmM8lzeNKCgYV1bOY2: {
          nick: 'Vinybergamo',
          operatorId: 'THNDR',
          position: 93,
          rank: 61,
          value: 1,
        },
        Qlh5bdY7u6chZ8ttXuAqjUvaw323: {
          nick: 'SEKAI',
          operatorId: 'THNDR',
          position: 44,
          rank: 39,
          value: 2,
        },
        RwWxnCZrXVed2Unj4EbINAQ55TC3: {
          nick: 'uwildie2',
          operatorId: 'THNDR',
          position: 75,
          rank: 61,
          value: 1,
        },
        T3aOJwMSzjQsfDu0TzTLZFDfE6G2: {
          nick: 'Taetay420 ',
          operatorId: 'THNDR',
          position: 70,
          rank: 61,
          value: 1,
        },
        TjqSO6wWUPgRhAHkk6uKf0XC5ve2: {
          nick: 'gjoy ali',
          operatorId: 'THNDR',
          position: 21,
          rank: 21,
          value: 5,
        },
        UPAdHYrMNde83CQM1QbOPVo4i1o2: {
          nick: 'Bieganiec',
          operatorId: 'THNDR',
          position: 78,
          rank: 61,
          value: 1,
        },
        VQ21Q4670YhnSk3GrAM6pbLQ6kq2: {
          nick: 'MonkeyMan',
          operatorId: 'THNDR',
          position: 50,
          rank: 39,
          value: 2,
        },
        VQCcQDtIKgTuJb8S0zBo7TARmxl2: {
          nick: 'kawaikea',
          operatorId: 'THNDR',
          position: 12,
          rank: 12,
          value: 8,
        },
        XVIggAUsLugui5MBMzna8bOmIqK2: {
          nick: 'MollyQue',
          operatorId: 'THNDR',
          position: 62,
          rank: 61,
          value: 1,
        },
        Y9WNeztb3UNdueuYgKSDObJftua2: {
          nick: 'moonp1e88 ',
          operatorId: 'THNDR',
          position: 66,
          rank: 61,
          value: 1,
        },
        Z8w76Fyin8hT5MtDJfl9YJ8qmoZ2: {
          nick: 'kheefleek ',
          operatorId: 'THNDR',
          position: 31,
          rank: 25,
          value: 4,
        },
        Zaqo7osp1fgDHKV1xqq7vRAzl6k2: {
          nick: 'maxpow',
          operatorId: 'THNDR',
          position: 42,
          rank: 39,
          value: 2,
        },
        ZkoCf7kXVDfowrts5pSLfjNCVFr2: {
          nick: 'godneverdie',
          operatorId: 'THNDR',
          position: 1,
          rank: 1,
          value: 54,
        },
        'a0dbf0bb-65bf-442a-81e4-f04d6de319e8': {
          nick: 'player42964',
          operatorId: 'telegram',
          position: 92,
          rank: 61,
          value: 1,
        },
        'a9863cef-a685-42c3-872b-aea054ad02d8': {
          nick: 'Jsurkes',
          operatorId: 'telegram',
          position: 94,
          rank: 61,
          value: 1,
        },
        aQ4boibSzZgJhL1hr0YQ8dTaFEX2: {
          nick: 'spacekais',
          operatorId: 'THNDR',
          position: 28,
          rank: 25,
          value: 4,
        },
        'aefd3fb3-65ed-4832-a630-acb913053ffb': {
          nick: 'Lucas Hubbard',
          operatorId: 'speed',
          position: 61,
          rank: 61,
          value: 1,
        },
        btN5UEmd1wVf9DSPFLF2GigzaP03: {
          nick: 'theMightynah',
          operatorId: 'THNDR',
          position: 19,
          rank: 18,
          value: 6,
        },
        cLVJXQObd7Q7CTYRJT0asGIG4ub2: {
          nick: 'leokim',
          operatorId: 'THNDR',
          position: 25,
          rank: 25,
          value: 4,
        },
        'd3fad122-0682-41fd-8f55-0f5e6460bed5': {
          nick: 'OSWIL ADONIYAS SOTO REVOLORIO',
          operatorId: 'speed',
          position: 46,
          rank: 39,
          value: 2,
        },
        'd70cd470-e589-4075-9a76-42e20da006cd': {
          nick: 'player92633',
          operatorId: 'telegram',
          position: 4,
          rank: 4,
          value: 17,
        },
        'd8c132b6-b0dd-4b2c-a54b-d0b3bd214169': {
          nick: 'Luis Enrique Hernandez',
          operatorId: 'speed',
          position: 49,
          rank: 39,
          value: 2,
        },
        'ddb64a25-32bc-4d73-9984-9f23fad233b6': {
          nick: 'justthatdude22',
          operatorId: 'speed',
          position: 34,
          rank: 33,
          value: 3,
        },
        'def07f6c-e89b-4ccd-bb53-4b35f7945d1d': {
          nick: 'lulu74100',
          operatorId: 'telegram',
          position: 100,
          rank: 61,
          value: 1,
        },
        'e46d0efc-bedb-41d7-ab9b-7bcc90c190e2': {
          nick: 'Redi 5A',
          operatorId: 'speed',
          position: 98,
          rank: 61,
          value: 1,
        },
        'e800b00b-76d7-484c-8799-9aea34102c5b': {
          nick: 'Robert Titze',
          operatorId: 'speed',
          position: 90,
          rank: 61,
          value: 1,
        },
        eOAV5NVHQmVnL3Pl6fryQ7C3O0C3: {
          nick: 'jeaclaphi',
          operatorId: 'THNDR',
          position: 37,
          rank: 33,
          value: 3,
        },
        'ebba3541-dddd-402c-a490-a187f976615f': {
          nick: 'Vincent Munoz',
          operatorId: 'speed',
          position: 91,
          rank: 61,
          value: 1,
        },
        'ed515bf0-75ed-4319-a22c-7712aa182791': {
          nick: 'rgalexander216',
          operatorId: 'betopenly',
          position: 2,
          rank: 2,
          value: 33,
        },
        'f067b3f1-3620-4ea9-ac84-18de42911edf': {
          nick: 'neckfoot',
          operatorId: 'betopenly',
          position: 88,
          rank: 61,
          value: 1,
        },
        'f52402da-f5b0-41cc-bb18-1fb7d8164dbe': {
          nick: 'player66627',
          operatorId: 'telegram',
          position: 57,
          rank: 39,
          value: 2,
        },
        'f5d3c9b7-0bd9-46ae-85a7-d362f5c9cd6e': {
          nick: 'Jessie Riddle',
          operatorId: 'speed',
          position: 69,
          rank: 61,
          value: 1,
        },
        'f84f0522-8325-4b53-903d-b04230e14eda': {
          nick: 'Rexdentron',
          operatorId: 'telegram',
          position: 14,
          rank: 12,
          value: 8,
        },
        fXFhQ9zDqwZhaqoJTzYSWDoMjn52: {
          nick: 'player2568',
          operatorId: 'THNDR',
          position: 77,
          rank: 61,
          value: 1,
        },
        'fbb1c655-9a77-4904-b8d5-1aa516a35127': {
          nick: 'Jeremy Johnson',
          operatorId: 'speed',
          position: 45,
          rank: 39,
          value: 2,
        },
        'fe050371-7080-4d65-b911-1ea479d242ae': {
          nick: 'Chiman Jerome',
          operatorId: 'speed',
          position: 35,
          rank: 33,
          value: 3,
        },
        gf1spz6Jmsg3wMycVm7RyMKERNs1: {
          nick: 'littleminer',
          operatorId: 'THNDR',
          position: 27,
          rank: 25,
          value: 4,
        },
        ixSu7EbpUhbswPZZuRY8cTzoBwy2: {
          nick: 'mailla888',
          operatorId: 'THNDR',
          position: 38,
          rank: 33,
          value: 3,
        },
        m71e9TEHcQVI6gNtKnOA9V8uKCc2: {
          nick: 'Nat',
          operatorId: 'THNDR',
          position: 53,
          rank: 39,
          value: 2,
        },
        meK5vW1SDdUv5ZK7idQyWHqXYKR2: {
          nick: 'wso18',
          operatorId: 'THNDR',
          position: 18,
          rank: 18,
          value: 6,
        },
        nToQ1lWacwVaiZ10wmzaXUYd1dS2: {
          nick: 'gastongg5',
          operatorId: 'THNDR',
          position: 56,
          rank: 39,
          value: 2,
        },
        p3ygX7hM2ySITzvqblh5aQv7lxz1: {
          nick: 'prettylady85 ',
          operatorId: 'THNDR',
          position: 71,
          rank: 61,
          value: 1,
        },
        pJEGDyOweoTEKlJ0NsALblBYgpb2: {
          nick: 'Diegote',
          operatorId: 'THNDR',
          position: 7,
          rank: 7,
          value: 15,
        },
        qENvX9vRToPBnFcTB5d69zq8Vog1: {
          nick: 'b3snakes',
          operatorId: 'THNDR',
          position: 64,
          rank: 61,
          value: 1,
        },
        qpgdvttycFQIv9fZJOIHGytNznO2: {
          nick: 'mwg',
          operatorId: 'THNDR',
          position: 58,
          rank: 39,
          value: 2,
        },
        r9pPvrYvbWZEo2ZFtXnmEEjyifN2: {
          nick: 'DeeRugs',
          operatorId: 'THNDR',
          position: 63,
          rank: 61,
          value: 1,
        },
        rzGu7cLdufZu7neHj72ioj4lqmt2: {
          nick: 'harlsbishhh96',
          operatorId: 'THNDR',
          position: 87,
          rank: 61,
          value: 1,
        },
        s0Qlml5rUfftTdPvAOEfBeaGslT2: {
          nick: 'katie',
          operatorId: 'THNDR',
          position: 3,
          rank: 3,
          value: 19,
        },
        tR64VxeOkaPQpJTmzWFYWGWe35k2: {
          nick: 'Scammer',
          operatorId: 'THNDR',
          position: 9,
          rank: 9,
          value: 11,
        },
        vyjpq2S6S6YSRu5kaBl6OYR4ae42: {
          nick: 'CryptoMeow',
          operatorId: 'THNDR',
          position: 96,
          rank: 61,
          value: 1,
        },
        wwACEIvG3LWbirz1Axs5XM0RDyh2: {
          nick: 'DemonaZA',
          operatorId: 'THNDR',
          position: 67,
          rank: 61,
          value: 1,
        },
        x9VO8NZNT9QRnpxpKImdBk1gtVi1: {
          nick: 'Twiztidcrypto',
          operatorId: 'THNDR',
          position: 68,
          rank: 61,
          value: 1,
        },
        xzAT9NH68HPeTE1vmEjulAsl1X33: {
          nick: 'BlockRock',
          operatorId: 'THNDR',
          position: 80,
          rank: 61,
          value: 1,
        },
      },
    },
  },
};

export const LEADERBOARD_MOSTWINS_7DAY = {
  status: 200,
  body: {
    status: 200,
    msg: 'Leaderboard',
    data: {
      lastUpdated: 1741615204776,
      leaderboardData: {
        '0ANFbHbkKXgv2ss6NJ1oLB5jxli2': {
          nick: 'Woo',
          operatorId: 'THNDR',
          position: 62,
          rank: 61,
          value: 10,
        },
        '0fc87d3c-b113-471d-b1b8-fcb8ffb0c147': {
          nick: 'player26129',
          operatorId: 'telegram',
          position: 86,
          rank: 75,
          value: 7,
        },
        '1ca18461-1a7f-4889-b084-57365f879290': {
          nick: 'Jayjay Garcia',
          operatorId: 'speed',
          position: 68,
          rank: 67,
          value: 9,
        },
        '1dacdc28-62c9-46e5-97bb-a8695195f333': {
          nick: 'Pedro Oliveira',
          operatorId: 'speed',
          position: 26,
          rank: 23,
          value: 25,
        },
        '21902c78-d99e-45e7-b050-f1ac3e37807b': {
          nick: 'Flemmon Cochran',
          operatorId: 'speed',
          position: 59,
          rank: 56,
          value: 11,
        },
        '295k0YwRKFSfT9V2RYC3S10FgCk2': {
          nick: 'Ziggy9044',
          operatorId: 'THNDR',
          position: 43,
          rank: 42,
          value: 14,
        },
        '2OG2GPZLspQajQxzIcBsTvVy6XH2': {
          nick: 'Rai',
          operatorId: 'THNDR',
          position: 66,
          rank: 61,
          value: 10,
        },
        '2UXKtKldCtUSajNQMrr0Em5hvfR2': {
          nick: 'Dat Nguyen',
          operatorId: 'THNDR',
          position: 75,
          rank: 75,
          value: 7,
        },
        '2defb36e-e698-4679-800b-be052c7e174a': {
          nick: 'Erin Hagg',
          operatorId: 'speed',
          position: 93,
          rank: 87,
          value: 6,
        },
        '2f695159-4099-4b89-b38e-1468dd7cfc95': {
          nick: 'jbrug420',
          operatorId: 'betopenly',
          position: 52,
          rank: 46,
          value: 12,
        },
        '2f9ccb6c-fea1-46c4-bcb3-0214c4abaf04': {
          nick: 'chessfan777',
          operatorId: 'betopenly',
          position: 13,
          rank: 13,
          value: 37,
        },
        '2qsJppEJzRdvljATq5tYTtdAeyF3': {
          nick: 'AngryKat1 ',
          operatorId: 'THNDR',
          position: 58,
          rank: 56,
          value: 11,
        },
        '3250050e-ad3a-4d06-b779-bcc1b532dfe0': {
          nick: 'PazZayy',
          operatorId: 'telegram',
          position: 7,
          rank: 7,
          value: 47,
        },
        '3bnFOv8BG2cN2nNZMEl3oy5ebMz2': {
          nick: 'MGBE',
          operatorId: 'THNDR',
          position: 94,
          rank: 87,
          value: 6,
        },
        '3ea87329-d5f2-41aa-b593-8246480cebe4': {
          nick: 'player59273',
          operatorId: 'telegram',
          position: 80,
          rank: 75,
          value: 7,
        },
        '42280e00-0e2d-41a9-aaac-05e9c0b84826': {
          nick: 'Passiveuro',
          operatorId: 'telegram',
          position: 89,
          rank: 87,
          value: 6,
        },
        '46938e4c-bc24-45cd-9b93-460eef349086': {
          nick: 'Neshdan',
          operatorId: 'telegram',
          position: 8,
          rank: 7,
          value: 47,
        },
        '4I7HWcHGprVlEzbKOdrxCKAp49x1': {
          nick: 'Kendrab23',
          operatorId: 'THNDR',
          position: 21,
          rank: 21,
          value: 29,
        },
        '4aa0ed64-17d4-42ac-80dc-9276c6b261e5': {
          nick: 'James Ferrell',
          operatorId: 'speed',
          position: 20,
          rank: 19,
          value: 30,
        },
        '5QfuKqzJ77cjIzIMpbirJPKig8w2': {
          nick: 'BtceXMasteR',
          operatorId: 'THNDR',
          position: 23,
          rank: 23,
          value: 25,
        },
        '6Fm0l4fZNiY7nFsqEOnmWdOWvEk1': {
          nick: 'kekiel0021300',
          operatorId: 'THNDR',
          position: 55,
          rank: 46,
          value: 12,
        },
        '6tBeqBz9iNS6I5MIGK6arVhuLOX2': {
          nick: 'We444072889',
          operatorId: 'THNDR',
          position: 77,
          rank: 75,
          value: 7,
        },
        '70027afc-c3fa-4933-b810-fe0b2167a24a': {
          nick: 'Lucas Henssler',
          operatorId: 'speed',
          position: 97,
          rank: 87,
          value: 6,
        },
        '71fcc902-113d-4a36-8f6d-3b7e9f84d50c': {
          nick: 'OmarCripto86',
          operatorId: 'telegram',
          position: 5,
          rank: 5,
          value: 70,
        },
        '754a6395-04f9-4d0d-a9fc-4cef356edae3': {
          nick: 'lukep2002',
          operatorId: 'betopenly',
          position: 38,
          rank: 38,
          value: 17,
        },
        '791ac21c-bc5b-4f2a-9e44-11dd2b672bac': {
          nick: 'Roneil Cayetano',
          operatorId: 'speed',
          position: 78,
          rank: 75,
          value: 7,
        },
        '7hJKmzdLguYHE8XsshEA1t6xLCM2': {
          nick: 'Maco0404',
          operatorId: 'THNDR',
          position: 12,
          rank: 11,
          value: 39,
        },
        '7iy1eIPdxxZkmVFi9IcNsIXUc3x1': {
          nick: 'ww815',
          operatorId: 'THNDR',
          position: 84,
          rank: 75,
          value: 7,
        },
        '86c32412-7374-49d1-a9d7-0ecfb4630127': {
          nick: 'Dheyaisgavidia',
          operatorId: 'telegram',
          position: 88,
          rank: 87,
          value: 6,
        },
        '877628a5-7dae-445b-b698-567459c035a9': {
          nick: 'Kevin Zuhaus',
          operatorId: 'speed',
          position: 72,
          rank: 69,
          value: 8,
        },
        '892383d9-10e4-40bd-bdda-922b296f9bec': {
          nick: 'Kody Laurent',
          operatorId: 'speed',
          position: 91,
          rank: 87,
          value: 6,
        },
        '9Y7FojpTt0XkYW1RoufrOvV2sgI2': {
          nick: 'quite ',
          operatorId: 'THNDR',
          position: 99,
          rank: 99,
          value: 5,
        },
        '9d9d67d7-88c0-4c96-b5d3-03d0d7cea8a8': {
          nick: 'Farshad Hajinejad',
          operatorId: 'speed',
          position: 31,
          rank: 29,
          value: 22,
        },
        '9oPTDONwyvXcifEZO2BJG9rbZeP2': {
          nick: 'serberuz',
          operatorId: 'THNDR',
          position: 71,
          rank: 69,
          value: 8,
        },
        A8OIhvNl2eV87S7o8RmrOOr2eLl2: {
          nick: 'DabroX',
          operatorId: 'THNDR',
          position: 22,
          rank: 22,
          value: 26,
        },
        AR1fJqJZqLSHFt9UtBQELu9J2C42: {
          nick: 'GA99Y',
          operatorId: 'THNDR',
          position: 47,
          rank: 46,
          value: 12,
        },
        B7W0BEKPOFfKcyuxHBO4S2tNqIU2: {
          nick: 'RuegoOhYXZqqh7',
          operatorId: 'THNDR',
          position: 35,
          rank: 35,
          value: 20,
        },
        BIMH6yaAn7NapBRCl03x7na5Ji73: {
          nick: 'random39',
          operatorId: 'THNDR',
          position: 70,
          rank: 69,
          value: 8,
        },
        BXVUCyEqCpXrcUki8yfi54KGnsK2: {
          nick: 'ryguy',
          operatorId: 'THNDR',
          position: 53,
          rank: 46,
          value: 12,
        },
        D6ZUd5lTRoMmsFEYJLaEwQuEvlN2: {
          nick: 'Mafan1982',
          operatorId: 'THNDR',
          position: 98,
          rank: 87,
          value: 6,
        },
        DDvKjZX7HJcwzoE5pg3NfjAERIv1: {
          nick: 'PrestonsGirl ',
          operatorId: 'THNDR',
          position: 41,
          rank: 41,
          value: 16,
        },
        E3PPyFdgU2cCYUQ02Gk35OHSHbo2: {
          nick: 'richmondtina',
          operatorId: 'THNDR',
          position: 63,
          rank: 61,
          value: 10,
        },
        E8xWOaODAmdoTjE9ybmBf7KRqYF3: {
          nick: 'Ondracoin33 ',
          operatorId: 'THNDR',
          position: 44,
          rank: 42,
          value: 14,
        },
        EH28THF8y1gU8fM89ykJJkmYP9T2: {
          nick: 'Rexdentron',
          operatorId: 'THNDR',
          position: 9,
          rank: 9,
          value: 46,
        },
        EVyM1oeCRCVVbO9OqPAedE52Mck2: {
          nick: 'puerto',
          operatorId: 'THNDR',
          position: 82,
          rank: 75,
          value: 7,
        },
        Eb1dnspHYUSrNEB2ZzLXrE0cDGk2: {
          nick: 'Dik',
          operatorId: 'THNDR',
          position: 64,
          rank: 61,
          value: 10,
        },
        HH3QVer20pSQ3u6YN3ikWipDi2N2: {
          nick: 'yukselcet',
          operatorId: 'THNDR',
          position: 79,
          rank: 75,
          value: 7,
        },
        HSvrg5cGIjRayV4leACZIuI0mVx1: {
          nick: 'Roseline292',
          operatorId: 'THNDR',
          position: 33,
          rank: 33,
          value: 21,
        },
        JqiNCGXjkaMqEYFPOYCaW0qcYfl1: {
          nick: 'privateprinzesska',
          operatorId: 'THNDR',
          position: 24,
          rank: 23,
          value: 25,
        },
        KiOEvN2HmFSmybQ4ZN9c3FeJwNN2: {
          nick: 'baes',
          operatorId: 'THNDR',
          position: 85,
          rank: 75,
          value: 7,
        },
        LhoQSyiO1ZPeJrQSgHMXxDhOshw1: {
          nick: 'Louie22',
          operatorId: 'THNDR',
          position: 32,
          rank: 29,
          value: 22,
        },
        MqL8KlOXGNajWFThPljAFpLiipX2: {
          nick: 'Running',
          operatorId: 'THNDR',
          position: 76,
          rank: 75,
          value: 7,
        },
        PSc4nkg5E8MmM8lzeNKCgYV1bOY2: {
          nick: 'Vinybergamo',
          operatorId: 'THNDR',
          position: 90,
          rank: 87,
          value: 6,
        },
        S1CP9f9tTHYHiFysaphIIetuzHW2: {
          nick: 'ogsythses',
          operatorId: 'THNDR',
          position: 25,
          rank: 23,
          value: 25,
        },
        SZNpkP4YeYM6emUlJJcPuvlKJE72: {
          nick: 'Rhea',
          operatorId: 'THNDR',
          position: 37,
          rank: 37,
          value: 18,
        },
        TUiqA4Q6EaTCwRVJuYCzUDgvLSC3: {
          nick: 'Xtypicalboy',
          operatorId: 'THNDR',
          position: 28,
          rank: 28,
          value: 23,
        },
        Tca2vWT3mqUKzfPjSCh3KkRgwf83: {
          nick: 'ashelk12',
          operatorId: 'THNDR',
          position: 49,
          rank: 46,
          value: 12,
        },
        TjqSO6wWUPgRhAHkk6uKf0XC5ve2: {
          nick: 'gjoy ali',
          operatorId: 'THNDR',
          position: 100,
          rank: 99,
          value: 5,
        },
        UPAdHYrMNde83CQM1QbOPVo4i1o2: {
          nick: 'Bieganiec',
          operatorId: 'THNDR',
          position: 69,
          rank: 69,
          value: 8,
        },
        VQ21Q4670YhnSk3GrAM6pbLQ6kq2: {
          nick: 'MonkeyMan',
          operatorId: 'THNDR',
          position: 16,
          rank: 16,
          value: 34,
        },
        VQCcQDtIKgTuJb8S0zBo7TARmxl2: {
          nick: 'kawaikea',
          operatorId: 'THNDR',
          position: 36,
          rank: 36,
          value: 19,
        },
        Yvi8ALOpPrWW86pg85iX6O7xd493: {
          nick: 'peterson3223',
          operatorId: 'THNDR',
          position: 95,
          rank: 87,
          value: 6,
        },
        Z8w76Fyin8hT5MtDJfl9YJ8qmoZ2: {
          nick: 'kheefleek ',
          operatorId: 'THNDR',
          position: 30,
          rank: 29,
          value: 22,
        },
        Zaqo7osp1fgDHKV1xqq7vRAzl6k2: {
          nick: 'maxpow',
          operatorId: 'THNDR',
          position: 46,
          rank: 46,
          value: 12,
        },
        ZkoCf7kXVDfowrts5pSLfjNCVFr2: {
          nick: 'godneverdie',
          operatorId: 'THNDR',
          position: 1,
          rank: 1,
          value: 138,
        },
        'a1bafd95-f9c1-48e3-b2d0-1bd807764685': {
          nick: 'ali marada',
          operatorId: 'speed',
          position: 60,
          rank: 56,
          value: 11,
        },
        'a229f554-3d73-4e46-84ba-94d9560b53d2': {
          nick: 'Scott Rhoten',
          operatorId: 'speed',
          position: 83,
          rank: 75,
          value: 7,
        },
        'a9863cef-a685-42c3-872b-aea054ad02d8': {
          nick: 'Jsurkes',
          operatorId: 'telegram',
          position: 39,
          rank: 38,
          value: 17,
        },
        aQ4boibSzZgJhL1hr0YQ8dTaFEX2: {
          nick: 'spacekais',
          operatorId: 'THNDR',
          position: 57,
          rank: 56,
          value: 11,
        },
        'aefd3fb3-65ed-4832-a630-acb913053ffb': {
          nick: 'Lucas Hubbard',
          operatorId: 'speed',
          position: 45,
          rank: 45,
          value: 13,
        },
        btN5UEmd1wVf9DSPFLF2GigzaP03: {
          nick: 'theMightynah',
          operatorId: 'THNDR',
          position: 87,
          rank: 87,
          value: 6,
        },
        'c3336823-eef0-4454-ac85-f25b9217e099': {
          nick: 'player84696',
          operatorId: 'telegram',
          position: 96,
          rank: 87,
          value: 6,
        },
        cLVJXQObd7Q7CTYRJT0asGIG4ub2: {
          nick: 'leokim',
          operatorId: 'THNDR',
          position: 42,
          rank: 42,
          value: 14,
        },
        ceeWs4u2PaMHUifqGrcjwtEPVpe2: {
          nick: 'Maco04',
          operatorId: 'THNDR',
          position: 34,
          rank: 33,
          value: 21,
        },
        'd70cd470-e589-4075-9a76-42e20da006cd': {
          nick: 'player99966',
          operatorId: 'telegram',
          position: 10,
          rank: 10,
          value: 42,
        },
        'ddb64a25-32bc-4d73-9984-9f23fad233b6': {
          nick: 'justthatdude22',
          operatorId: 'speed',
          position: 61,
          rank: 61,
          value: 10,
        },
        dhRg94DlEdRvFHiXuNTNNeHVDBV2: {
          nick: 'PainKiller',
          operatorId: 'THNDR',
          position: 67,
          rank: 67,
          value: 9,
        },
        'e8fc3e24-5a86-407e-890c-95ff3009b2ee': {
          nick: 'Omid ariya',
          operatorId: 'speed',
          position: 54,
          rank: 46,
          value: 12,
        },
        'e958b29d-7cae-4ef2-b360-f5e52f131caa': {
          nick: 'Akos Pinter',
          operatorId: 'speed',
          position: 51,
          rank: 46,
          value: 12,
        },
        eOAV5NVHQmVnL3Pl6fryQ7C3O0C3: {
          nick: 'jeaclaphi',
          operatorId: 'THNDR',
          position: 18,
          rank: 18,
          value: 31,
        },
        'ed515bf0-75ed-4319-a22c-7712aa182791': {
          nick: 'rgalexander216',
          operatorId: 'betopenly',
          position: 2,
          rank: 2,
          value: 108,
        },
        'f067b3f1-3620-4ea9-ac84-18de42911edf': {
          nick: 'neckfoot',
          operatorId: 'betopenly',
          position: 6,
          rank: 6,
          value: 55,
        },
        'f84f0522-8325-4b53-903d-b04230e14eda': {
          nick: 'Rexdentron',
          operatorId: 'telegram',
          position: 56,
          rank: 56,
          value: 11,
        },
        'f8d8cab0-22c1-41aa-aad4-50e3fe759d9f': {
          nick: 'Katia Ticuta',
          operatorId: 'speed',
          position: 81,
          rank: 75,
          value: 7,
        },
        'fcc82108-0f0f-4983-83e9-eda9470abc46': {
          nick: 'James Stavros II',
          operatorId: 'speed',
          position: 74,
          rank: 69,
          value: 8,
        },
        gfo53QJFheeg3czzp2zI6OuLFWk2: {
          nick: '1000 is not enough',
          operatorId: 'THNDR',
          position: 15,
          rank: 14,
          value: 36,
        },
        meK5vW1SDdUv5ZK7idQyWHqXYKR2: {
          nick: 'wso18',
          operatorId: 'THNDR',
          position: 11,
          rank: 11,
          value: 39,
        },
        mnC7qAmth4PsCcsyfqlXCiADlhr1: {
          nick: 'Elu4454',
          operatorId: 'THNDR',
          position: 14,
          rank: 14,
          value: 36,
        },
        nP60EyRrzqey5mKWNVujhd7WvP72: {
          nick: 'arvo75 ',
          operatorId: 'THNDR',
          position: 73,
          rank: 69,
          value: 8,
        },
        nToQ1lWacwVaiZ10wmzaXUYd1dS2: {
          nick: 'gastongg5',
          operatorId: 'THNDR',
          position: 29,
          rank: 29,
          value: 22,
        },
        pFHblNG3yyPrtOCq4Zwb4CYvFdB3: {
          nick: 'amaleshko',
          operatorId: 'THNDR',
          position: 48,
          rank: 46,
          value: 12,
        },
        pJEGDyOweoTEKlJ0NsALblBYgpb2: {
          nick: 'Diegote',
          operatorId: 'THNDR',
          position: 4,
          rank: 4,
          value: 73,
        },
        pmHdAvn3G0Q9ZmazYNvuGxDFBEA2: {
          nick: 'nacho',
          operatorId: 'THNDR',
          position: 92,
          rank: 87,
          value: 6,
        },
        qENvX9vRToPBnFcTB5d69zq8Vog1: {
          nick: 'b3snakes',
          operatorId: 'THNDR',
          position: 17,
          rank: 17,
          value: 32,
        },
        s0Qlml5rUfftTdPvAOEfBeaGslT2: {
          nick: 'katie',
          operatorId: 'THNDR',
          position: 3,
          rank: 3,
          value: 100,
        },
        skgHapOl78YI5kbUTU4hnfZZeCt1: {
          nick: 'ustn26',
          operatorId: 'THNDR',
          position: 65,
          rank: 61,
          value: 10,
        },
        tR64VxeOkaPQpJTmzWFYWGWe35k2: {
          nick: 'Scammer',
          operatorId: 'THNDR',
          position: 19,
          rank: 19,
          value: 30,
        },
        vbeiYxytClOFdnTKBK28l05yP7F3: {
          nick: 'Katie',
          operatorId: 'THNDR',
          position: 40,
          rank: 38,
          value: 17,
        },
        vfrqXxPqY9WZPSbem0Clz8vyRTn1: {
          nick: 'passie',
          operatorId: 'THNDR',
          position: 50,
          rank: 46,
          value: 12,
        },
        wwACEIvG3LWbirz1Axs5XM0RDyh2: {
          nick: 'DemonaZA',
          operatorId: 'THNDR',
          position: 27,
          rank: 27,
          value: 24,
        },
      },
    },
  },
};

export const LEADERBOARD_MOSTWINS_30DAY = {
  status: 200,
  body: {
    status: 200,
    msg: 'Leaderboard',
    data: {
      lastUpdated: 1741615204776,
      leaderboardData: {
        '0ANFbHbkKXgv2ss6NJ1oLB5jxli2': {
          nick: 'Woo',
          operatorId: 'THNDR',
          position: 2,
          rank: 2,
          value: 296,
        },
        '124be09a-fff4-4374-ae3e-8dc032702697': {
          nick: 'kostya nnn',
          operatorId: 'speed',
          position: 53,
          rank: 52,
          value: 53,
        },
        '1ca18461-1a7f-4889-b084-57365f879290': {
          nick: 'Jayjay Garcia',
          operatorId: 'speed',
          position: 39,
          rank: 38,
          value: 64,
        },
        '1d9f64b7-eeaa-4d25-9335-bb701bebfe70': {
          nick: 'conch',
          operatorId: 'betopenly',
          position: 56,
          rank: 55,
          value: 50,
        },
        '1dacdc28-62c9-46e5-97bb-a8695195f333': {
          nick: 'Pedro Oliveira',
          operatorId: 'speed',
          position: 52,
          rank: 52,
          value: 53,
        },
        '21902c78-d99e-45e7-b050-f1ac3e37807b': {
          nick: 'Flemmon Cochran',
          operatorId: 'speed',
          position: 15,
          rank: 15,
          value: 119,
        },
        '225f86af-d71b-467d-bff4-44b9fff35204': {
          nick: 'Logan Elberson',
          operatorId: 'speed',
          position: 71,
          rank: 70,
          value: 40,
        },
        '295k0YwRKFSfT9V2RYC3S10FgCk2': {
          nick: 'Ziggy9044',
          operatorId: 'THNDR',
          position: 97,
          rank: 96,
          value: 29,
        },
        '2f9ccb6c-fea1-46c4-bcb3-0214c4abaf04': {
          nick: 'chessfan777',
          operatorId: 'betopenly',
          position: 38,
          rank: 38,
          value: 64,
        },
        '3250050e-ad3a-4d06-b779-bcc1b532dfe0': {
          nick: 'PazZayy',
          operatorId: 'telegram',
          position: 7,
          rank: 7,
          value: 219,
        },
        '3cd545b4-5cef-4030-b598-ac9650f3032a': {
          nick: 'Gavin Livesey',
          operatorId: 'speed',
          position: 45,
          rank: 45,
          value: 56,
        },
        '46938e4c-bc24-45cd-9b93-460eef349086': {
          nick: 'Neshdan',
          operatorId: 'telegram',
          position: 5,
          rank: 5,
          value: 225,
        },
        '4I7HWcHGprVlEzbKOdrxCKAp49x1': {
          nick: 'Kendrab23',
          operatorId: 'THNDR',
          position: 35,
          rank: 34,
          value: 68,
        },
        '4aa0ed64-17d4-42ac-80dc-9276c6b261e5': {
          nick: 'James Ferrell',
          operatorId: 'speed',
          position: 90,
          rank: 89,
          value: 30,
        },
        '58f0cdf9-62a5-4516-b147-562ebd9e6925': {
          nick: 'wolfpack_trivia',
          operatorId: 'telegram',
          position: 79,
          rank: 78,
          value: 34,
        },
        '5Mzv0biDtURWH4EydiX8gIHpxWC3': {
          nick: 'RcEverSauce',
          operatorId: 'THNDR',
          position: 37,
          rank: 37,
          value: 65,
        },
        '5QfuKqzJ77cjIzIMpbirJPKig8w2': {
          nick: 'BtceXMasteR',
          operatorId: 'THNDR',
          position: 69,
          rank: 69,
          value: 41,
        },
        '5dd4ad6c-98f0-413e-87ec-762f7b954957': {
          nick: 'Donnell Schneider',
          operatorId: 'speed',
          position: 100,
          rank: 96,
          value: 29,
        },
        '5fc5b679-0c9e-42da-ab0e-70a94e17e3e3': {
          nick: 'Luis Espinoza',
          operatorId: 'speed',
          position: 46,
          rank: 45,
          value: 56,
        },
        '5jNmL86kHiNoVmH8V2a0CSj44Ys2': {
          nick: 'luzpurazo02',
          operatorId: 'THNDR',
          position: 28,
          rank: 28,
          value: 76,
        },
        '661edc86-6229-44dd-87b3-0d072132cd98': {
          nick: 'Kevin Cesar',
          operatorId: 'speed',
          position: 80,
          rank: 78,
          value: 34,
        },
        '71fcc902-113d-4a36-8f6d-3b7e9f84d50c': {
          nick: 'OmarCripto86',
          operatorId: 'telegram',
          position: 4,
          rank: 4,
          value: 271,
        },
        '7SxpldVWl9Yd0cmtMqOopOzaplD2': {
          nick: 'Jefe',
          operatorId: 'THNDR',
          position: 57,
          rank: 57,
          value: 48,
        },
        '7c9c87b4-b522-4689-8af2-9b889bb31bc3': {
          nick: 'mattford',
          operatorId: 'betopenly',
          position: 26,
          rank: 26,
          value: 84,
        },
        '7hJKmzdLguYHE8XsshEA1t6xLCM2': {
          nick: 'Maco0404',
          operatorId: 'THNDR',
          position: 32,
          rank: 32,
          value: 70,
        },
        '7iy1eIPdxxZkmVFi9IcNsIXUc3x1': {
          nick: 'ww815',
          operatorId: 'THNDR',
          position: 30,
          rank: 30,
          value: 74,
        },
        '86c32412-7374-49d1-a9d7-0ecfb4630127': {
          nick: 'Dheyaisgavidia',
          operatorId: 'telegram',
          position: 42,
          rank: 42,
          value: 61,
        },
        '898396f6-c68d-4e22-8ab2-51a73b9c151e': {
          nick: 'Ashleydamaniac Ashleydamaniac',
          operatorId: 'speed',
          position: 99,
          rank: 96,
          value: 29,
        },
        '8NkSyaqCHFbnrHdqu2hTdbAvIdp1': {
          nick: 'mamba mentality',
          operatorId: 'THNDR',
          position: 74,
          rank: 74,
          value: 39,
        },
        '9d9d67d7-88c0-4c96-b5d3-03d0d7cea8a8': {
          nick: 'Farshad Hajinejad',
          operatorId: 'speed',
          position: 33,
          rank: 33,
          value: 69,
        },
        A8OIhvNl2eV87S7o8RmrOOr2eLl2: {
          nick: 'DabroX',
          operatorId: 'THNDR',
          position: 96,
          rank: 96,
          value: 29,
        },
        B7W0BEKPOFfKcyuxHBO4S2tNqIU2: {
          nick: 'RuegoOhYXZqqh7',
          operatorId: 'THNDR',
          position: 91,
          rank: 89,
          value: 30,
        },
        D6ZUd5lTRoMmsFEYJLaEwQuEvlN2: {
          nick: 'Mafan1982',
          operatorId: 'THNDR',
          position: 93,
          rank: 89,
          value: 30,
        },
        DDvKjZX7HJcwzoE5pg3NfjAERIv1: {
          nick: 'PrestonsGirl ',
          operatorId: 'THNDR',
          position: 49,
          rank: 47,
          value: 55,
        },
        DquvTqsjUWhHmfwDxweisAaVbSs1: {
          nick: 'Jason B',
          operatorId: 'THNDR',
          position: 14,
          rank: 14,
          value: 122,
        },
        E3PPyFdgU2cCYUQ02Gk35OHSHbo2: {
          nick: 'richmondtina',
          operatorId: 'THNDR',
          position: 65,
          rank: 64,
          value: 44,
        },
        EH28THF8y1gU8fM89ykJJkmYP9T2: {
          nick: 'Rexdentron',
          operatorId: 'THNDR',
          position: 17,
          rank: 17,
          value: 117,
        },
        EVyM1oeCRCVVbO9OqPAedE52Mck2: {
          nick: 'puerto',
          operatorId: 'THNDR',
          position: 13,
          rank: 13,
          value: 127,
        },
        Eb1dnspHYUSrNEB2ZzLXrE0cDGk2: {
          nick: 'Dik',
          operatorId: 'THNDR',
          position: 62,
          rank: 61,
          value: 45,
        },
        ExEDXBkkpOMHLz2F1KVehXnWPQk2: {
          nick: 'ela7373',
          operatorId: 'THNDR',
          position: 83,
          rank: 81,
          value: 33,
        },
        Fj0SHclZIDapRYmq9FXThI9z6B73: {
          nick: 'Tecky42',
          operatorId: 'THNDR',
          position: 60,
          rank: 60,
          value: 46,
        },
        JqiNCGXjkaMqEYFPOYCaW0qcYfl1: {
          nick: 'privateprinzesska',
          operatorId: 'THNDR',
          position: 10,
          rank: 10,
          value: 190,
        },
        KCby6YRbgJZ6xV7XFWd6ltx3Ppf2: {
          nick: 'bagkoyy',
          operatorId: 'THNDR',
          position: 36,
          rank: 34,
          value: 68,
        },
        KiOEvN2HmFSmybQ4ZN9c3FeJwNN2: {
          nick: 'baes',
          operatorId: 'THNDR',
          position: 98,
          rank: 96,
          value: 29,
        },
        LhoQSyiO1ZPeJrQSgHMXxDhOshw1: {
          nick: 'Louie22',
          operatorId: 'THNDR',
          position: 24,
          rank: 24,
          value: 91,
        },
        MqL8KlOXGNajWFThPljAFpLiipX2: {
          nick: 'Running',
          operatorId: 'THNDR',
          position: 87,
          rank: 87,
          value: 31,
        },
        NHezp26RNOdWX1KZMgpCyzw57Mn1: {
          nick: 'ProfessorSyma',
          operatorId: 'THNDR',
          position: 59,
          rank: 57,
          value: 48,
        },
        OBvLyuG4l3ecP4zQaah1naAnNpy1: {
          nick: 'WhiteGangsta',
          operatorId: 'THNDR',
          position: 76,
          rank: 76,
          value: 36,
        },
        QOiTTYATaXShTSMQOt8MCcclV5n2: {
          nick: 'BadRabbit83',
          operatorId: 'THNDR',
          position: 95,
          rank: 89,
          value: 30,
        },
        Qtpru0X7cITeeccjSGVlZlZhASR2: {
          nick: 'sharlie98',
          operatorId: 'THNDR',
          position: 82,
          rank: 81,
          value: 33,
        },
        RBqDRktOYRaONpnrdbA3kgoZG1w2: {
          nick: 'bigchungus',
          operatorId: 'THNDR',
          position: 25,
          rank: 25,
          value: 86,
        },
        SZNpkP4YeYM6emUlJJcPuvlKJE72: {
          nick: 'Rhea',
          operatorId: 'THNDR',
          position: 50,
          rank: 50,
          value: 54,
        },
        T9oKlTDPOQVuVrsfy70Je17RPci2: {
          nick: 'roxie',
          operatorId: 'THNDR',
          position: 85,
          rank: 84,
          value: 32,
        },
        TUiqA4Q6EaTCwRVJuYCzUDgvLSC3: {
          nick: 'Xtypicalboy',
          operatorId: 'THNDR',
          position: 67,
          rank: 64,
          value: 44,
        },
        TjqSO6wWUPgRhAHkk6uKf0XC5ve2: {
          nick: 'gjoy ali',
          operatorId: 'THNDR',
          position: 81,
          rank: 81,
          value: 33,
        },
        UPAdHYrMNde83CQM1QbOPVo4i1o2: {
          nick: 'Bieganiec',
          operatorId: 'THNDR',
          position: 78,
          rank: 78,
          value: 34,
        },
        VQ21Q4670YhnSk3GrAM6pbLQ6kq2: {
          nick: 'MonkeyMan',
          operatorId: 'THNDR',
          position: 18,
          rank: 18,
          value: 113,
        },
        Z8w76Fyin8hT5MtDJfl9YJ8qmoZ2: {
          nick: 'kheefleek ',
          operatorId: 'THNDR',
          position: 40,
          rank: 40,
          value: 63,
        },
        ZMTLpjA302MAfCMB2ZUdHuvAlBp2: {
          nick: 'spideman',
          operatorId: 'THNDR',
          position: 48,
          rank: 47,
          value: 55,
        },
        ZP1PfEawyDcVCtIwqCFuGuFmP1U2: {
          nick: 'la mera verga',
          operatorId: 'THNDR',
          position: 19,
          rank: 19,
          value: 107,
        },
        ZW6WFa6spcacIjZDIrNyCXkICx12: {
          nick: 'shabnam ',
          operatorId: 'THNDR',
          position: 77,
          rank: 77,
          value: 35,
        },
        Zaqo7osp1fgDHKV1xqq7vRAzl6k2: {
          nick: 'maxpow',
          operatorId: 'THNDR',
          position: 41,
          rank: 41,
          value: 62,
        },
        ZkoCf7kXVDfowrts5pSLfjNCVFr2: {
          nick: 'godneverdie',
          operatorId: 'THNDR',
          position: 1,
          rank: 1,
          value: 323,
        },
        a4y5fBgpd1RK83yF9Nh2C1IBv4i2: {
          nick: 'prabinchd',
          operatorId: 'THNDR',
          position: 88,
          rank: 87,
          value: 31,
        },
        'a9863cef-a685-42c3-872b-aea054ad02d8': {
          nick: 'Jsurkes',
          operatorId: 'telegram',
          position: 61,
          rank: 61,
          value: 45,
        },
        aQ4boibSzZgJhL1hr0YQ8dTaFEX2: {
          nick: 'spacekais',
          operatorId: 'THNDR',
          position: 84,
          rank: 84,
          value: 32,
        },
        'aefd3fb3-65ed-4832-a630-acb913053ffb': {
          nick: 'Lucas Hubbard',
          operatorId: 'speed',
          position: 43,
          rank: 43,
          value: 59,
        },
        b02uR9KB8tYrSNLLLFDV7MV2vWL2: {
          nick: 'afshin',
          operatorId: 'THNDR',
          position: 12,
          rank: 12,
          value: 139,
        },
        'bba0b072-830d-4976-870b-6db6da04b19e': {
          nick: 'Shawn Dunlap',
          operatorId: 'speed',
          position: 94,
          rank: 89,
          value: 30,
        },
        'c8e102a7-3b11-4749-a03f-f722828e27f5': {
          nick: 'Daniarmando',
          operatorId: 'telegram',
          position: 23,
          rank: 23,
          value: 94,
        },
        cLVJXQObd7Q7CTYRJT0asGIG4ub2: {
          nick: 'leokim',
          operatorId: 'THNDR',
          position: 20,
          rank: 20,
          value: 106,
        },
        'ceca90a3-6ac2-476b-b5f5-8aadf250a220': {
          nick: 'ferrari16',
          operatorId: 'betopenly',
          position: 44,
          rank: 44,
          value: 58,
        },
        ceeWs4u2PaMHUifqGrcjwtEPVpe2: {
          nick: 'Maco04',
          operatorId: 'THNDR',
          position: 29,
          rank: 29,
          value: 75,
        },
        cphOez7gHeUlEKuROglUHJOqy8m2: {
          nick: 'Eve369',
          operatorId: 'THNDR',
          position: 63,
          rank: 61,
          value: 45,
        },
        'd70cd470-e589-4075-9a76-42e20da006cd': {
          nick: 'player99966',
          operatorId: 'telegram',
          position: 64,
          rank: 64,
          value: 44,
        },
        'ddb64a25-32bc-4d73-9984-9f23fad233b6': {
          nick: 'justthatdude22',
          operatorId: 'speed',
          position: 70,
          rank: 70,
          value: 40,
        },
        'e2746fef-0396-40e3-93e6-63f22f37d3fe': {
          nick: 'player67918',
          operatorId: 'telegram',
          position: 92,
          rank: 89,
          value: 30,
        },
        'e466aec5-c2d8-4d4a-aa1d-b69b985c3f6a': {
          nick: 'justint24',
          operatorId: 'betopenly',
          position: 72,
          rank: 70,
          value: 40,
        },
        eOAV5NVHQmVnL3Pl6fryQ7C3O0C3: {
          nick: 'jeaclaphi',
          operatorId: 'THNDR',
          position: 66,
          rank: 64,
          value: 44,
        },
        'ed515bf0-75ed-4319-a22c-7712aa182791': {
          nick: 'rgalexander216',
          operatorId: 'betopenly',
          position: 8,
          rank: 8,
          value: 209,
        },
        'f067b3f1-3620-4ea9-ac84-18de42911edf': {
          nick: 'neckfoot',
          operatorId: 'betopenly',
          position: 47,
          rank: 47,
          value: 55,
        },
        'faf8c5db-ed3e-43b5-8ef1-e094d67f585b': {
          nick: 'Jason Broderick',
          operatorId: 'speed',
          position: 16,
          rank: 16,
          value: 118,
        },
        'fb064219-c0d4-4ae5-9734-c9193a1b3eef': {
          nick: 'player36996',
          operatorId: 'telegram',
          position: 58,
          rank: 57,
          value: 48,
        },
        gf1spz6Jmsg3wMycVm7RyMKERNs1: {
          nick: 'littleminer',
          operatorId: 'THNDR',
          position: 31,
          rank: 31,
          value: 71,
        },
        gfo53QJFheeg3czzp2zI6OuLFWk2: {
          nick: '1000 is not enough',
          operatorId: 'THNDR',
          position: 9,
          rank: 9,
          value: 200,
        },
        hbtZNCdpAUT1e5vvhVAVpTvdKtx2: {
          nick: 'KassieTheMando',
          operatorId: 'THNDR',
          position: 75,
          rank: 75,
          value: 38,
        },
        iSktZeq7olZipQvAsBwPQ0kVQCk1: {
          nick: 'kball',
          operatorId: 'THNDR',
          position: 73,
          rank: 70,
          value: 40,
        },
        j1Z1WPziqYXZmsCqL8RrS2C4ED32: {
          nick: 'COFFI',
          operatorId: 'THNDR',
          position: 68,
          rank: 68,
          value: 43,
        },
        lTFxkD8kb4cU31Xucj8e7FIYfAk2: {
          nick: 'lulo',
          operatorId: 'THNDR',
          position: 51,
          rank: 50,
          value: 54,
        },
        meK5vW1SDdUv5ZK7idQyWHqXYKR2: {
          nick: 'wso18',
          operatorId: 'THNDR',
          position: 11,
          rank: 11,
          value: 153,
        },
        mnC7qAmth4PsCcsyfqlXCiADlhr1: {
          nick: 'Elu4454',
          operatorId: 'THNDR',
          position: 55,
          rank: 55,
          value: 50,
        },
        nuAygUHipvZoxHisDuv4GCk2mHe2: {
          nick: 'diyann',
          operatorId: 'THNDR',
          position: 21,
          rank: 21,
          value: 104,
        },
        pJEGDyOweoTEKlJ0NsALblBYgpb2: {
          nick: 'Diegote',
          operatorId: 'THNDR',
          position: 6,
          rank: 6,
          value: 223,
        },
        qENvX9vRToPBnFcTB5d69zq8Vog1: {
          nick: 'b3snakes',
          operatorId: 'THNDR',
          position: 34,
          rank: 34,
          value: 68,
        },
        qRmDm0SvbuYwfg7o9OCGNP8oCkJ2: {
          nick: 'Lixeeer',
          operatorId: 'THNDR',
          position: 86,
          rank: 84,
          value: 32,
        },
        s0Qlml5rUfftTdPvAOEfBeaGslT2: {
          nick: 'katie',
          operatorId: 'THNDR',
          position: 3,
          rank: 3,
          value: 292,
        },
        tR64VxeOkaPQpJTmzWFYWGWe35k2: {
          nick: 'Scammer',
          operatorId: 'THNDR',
          position: 89,
          rank: 89,
          value: 30,
        },
        vbeiYxytClOFdnTKBK28l05yP7F3: {
          nick: 'Katie',
          operatorId: 'THNDR',
          position: 54,
          rank: 54,
          value: 51,
        },
        vfrqXxPqY9WZPSbem0Clz8vyRTn1: {
          nick: 'passie',
          operatorId: 'THNDR',
          position: 22,
          rank: 22,
          value: 101,
        },
        wwACEIvG3LWbirz1Axs5XM0RDyh2: {
          nick: 'DemonaZA',
          operatorId: 'THNDR',
          position: 27,
          rank: 27,
          value: 83,
        },
      },
    },
  },
};

export const LEADERBOARD_MOSTWINS_ALLTIME = {
  status: 200,
  body: {
    status: 200,
    msg: 'Leaderboard',
    data: {
      lastUpdated: 1741615204776,
      leaderboardData: {
        '0ANFbHbkKXgv2ss6NJ1oLB5jxli2': {
          nick: 'Woo',
          operatorId: 'THNDR',
          position: 40,
          rank: 40,
          value: 318,
        },
        '1RZxIeoT5aOdCMyXEL1s6BrwQ2W2': {
          nick: 'skeelodripp',
          operatorId: 'THNDR',
          position: 91,
          rank: 91,
          value: 169,
        },
        '1d9f64b7-eeaa-4d25-9335-bb701bebfe70': {
          nick: 'conch',
          operatorId: 'betopenly',
          position: 39,
          rank: 39,
          value: 321,
        },
        '1f73e8e2-6a83-48ac-9698-1efe066c7311': {
          nick: 'ypalermo',
          operatorId: 'betopenly',
          position: 50,
          rank: 50,
          value: 272,
        },
        '22dbe726-a700-4dc2-8e81-9456f822ff4a': {
          nick: 'paulelias',
          operatorId: 'betopenly',
          position: 16,
          rank: 16,
          value: 738,
        },
        '2bigJaMNqcUKEZdjTpiIRQSyvjE3': {
          nick: 'rafaelpac',
          operatorId: 'THNDR',
          position: 12,
          rank: 12,
          value: 940,
        },
        '3250050e-ad3a-4d06-b779-bcc1b532dfe0': {
          nick: 'PazZayy',
          operatorId: 'telegram',
          position: 15,
          rank: 15,
          value: 781,
        },
        '3390a43f-c304-40d8-b38f-4d53321a3848': {
          nick: 'Crypto Keeper',
          operatorId: 'speed',
          position: 72,
          rank: 70,
          value: 201,
        },
        '44oOsdt9pCNXdfCjRK349seqID42': {
          nick: 'Franklin Saint',
          operatorId: 'THNDR',
          position: 67,
          rank: 66,
          value: 209,
        },
        '46938e4c-bc24-45cd-9b93-460eef349086': {
          nick: 'Neshdan',
          operatorId: 'telegram',
          position: 22,
          rank: 22,
          value: 477,
        },
        '4DVMucyDaTWO8ERtpEoatTqEBr52': {
          nick: 'D0G3',
          operatorId: 'THNDR',
          position: 35,
          rank: 35,
          value: 352,
        },
        '4W29W8plWNgZb3jFon56OFgNSHJ3': {
          nick: 'suckmydiesel',
          operatorId: 'THNDR',
          position: 81,
          rank: 81,
          value: 182,
        },
        '58f0cdf9-62a5-4516-b147-562ebd9e6925': {
          nick: 'wolfpack_trivia',
          operatorId: 'telegram',
          position: 70,
          rank: 70,
          value: 201,
        },
        '5Mzv0biDtURWH4EydiX8gIHpxWC3': {
          nick: 'RcEverSauce',
          operatorId: 'THNDR',
          position: 63,
          rank: 63,
          value: 216,
        },
        '5dd4ad6c-98f0-413e-87ec-762f7b954957': {
          nick: 'Donnell Schneider',
          operatorId: 'speed',
          position: 86,
          rank: 86,
          value: 176,
        },
        '5jNmL86kHiNoVmH8V2a0CSj44Ys2': {
          nick: 'luzpurazo02',
          operatorId: 'THNDR',
          position: 4,
          rank: 4,
          value: 1157,
        },
        '661edc86-6229-44dd-87b3-0d072132cd98': {
          nick: 'Kevin Cesar',
          operatorId: 'speed',
          position: 94,
          rank: 94,
          value: 166,
        },
        '71fcc902-113d-4a36-8f6d-3b7e9f84d50c': {
          nick: 'OmarCripto86',
          operatorId: 'telegram',
          position: 10,
          rank: 10,
          value: 1060,
        },
        '7c9c87b4-b522-4689-8af2-9b889bb31bc3': {
          nick: 'mattford',
          operatorId: 'betopenly',
          position: 23,
          rank: 23,
          value: 466,
        },
        '7hJKmzdLguYHE8XsshEA1t6xLCM2': {
          nick: 'Maco0404',
          operatorId: 'THNDR',
          position: 69,
          rank: 69,
          value: 206,
        },
        '7iy1eIPdxxZkmVFi9IcNsIXUc3x1': {
          nick: 'ww815',
          operatorId: 'THNDR',
          position: 82,
          rank: 81,
          value: 182,
        },
        '7tfVggLBeTgKDQ0nLdAxwxEGrWn1': {
          nick: 'Shutupandtakemymoney',
          operatorId: 'THNDR',
          position: 1,
          rank: 1,
          value: 2569,
        },
        '9aOtaNYDdUXyLF9penLFfF2LASv1': {
          nick: 'choppedliver',
          operatorId: 'THNDR',
          position: 65,
          rank: 65,
          value: 210,
        },
        '9w2z8liWEhOYZeVNiHrFIg54z0z1': {
          nick: 'colinmwest16',
          operatorId: 'THNDR',
          position: 77,
          rank: 76,
          value: 193,
        },
        B7W0BEKPOFfKcyuxHBO4S2tNqIU2: {
          nick: 'RuegoOhYXZqqh7',
          operatorId: 'THNDR',
          position: 49,
          rank: 49,
          value: 273,
        },
        BDj1hHMAFVXMIvbpp8AmMKTfI4x1: {
          nick: 'JankBella',
          operatorId: 'THNDR',
          position: 89,
          rank: 89,
          value: 171,
        },
        BMglpUv6WmhL4ul8NRRTqOfZb9v1: {
          nick: 'xaero10',
          operatorId: 'THNDR',
          position: 85,
          rank: 84,
          value: 181,
        },
        BOtfcwSyNZWtBLDnk4xPYb2uqWT2: {
          nick: 'jeepgirl15',
          operatorId: 'THNDR',
          position: 92,
          rank: 91,
          value: 169,
        },
        E3PPyFdgU2cCYUQ02Gk35OHSHbo2: {
          nick: 'richmondtina',
          operatorId: 'THNDR',
          position: 7,
          rank: 7,
          value: 1105,
        },
        EH28THF8y1gU8fM89ykJJkmYP9T2: {
          nick: 'Rexdentron',
          operatorId: 'THNDR',
          position: 11,
          rank: 11,
          value: 1004,
        },
        FDVuzw15HmYz5GyLVHy1JuMlGT33: {
          nick: 'Connor',
          operatorId: 'THNDR',
          position: 55,
          rank: 54,
          value: 261,
        },
        Fj0SHclZIDapRYmq9FXThI9z6B73: {
          nick: 'Tecky42',
          operatorId: 'THNDR',
          position: 26,
          rank: 26,
          value: 451,
        },
        GCuLSzNyeIMdtFwffzpCoCDRVPv1: {
          nick: 'harro',
          operatorId: 'THNDR',
          position: 17,
          rank: 17,
          value: 649,
        },
        HN4cjQOv0vSDMhmVEo2glGZFx9q1: {
          nick: 'nido76',
          operatorId: 'THNDR',
          position: 90,
          rank: 90,
          value: 170,
        },
        HSvrg5cGIjRayV4leACZIuI0mVx1: {
          nick: 'Roseline292',
          operatorId: 'THNDR',
          position: 95,
          rank: 95,
          value: 164,
        },
        IcvXSN5IGhMuc8Bjr15wTMUyRbj2: {
          nick: 'Bellesbeastzbdgg',
          operatorId: 'THNDR',
          position: 60,
          rank: 60,
          value: 230,
        },
        J0s1JgE9TfVJHCOHIoj3YrldPqn1: {
          nick: 'wgtbraz zdb gg',
          operatorId: 'THNDR',
          position: 41,
          rank: 40,
          value: 318,
        },
        JQCDZLR2P3fGQNKEQvUpF5Zc7if2: {
          nick: 'R aven',
          operatorId: 'THNDR',
          position: 68,
          rank: 68,
          value: 207,
        },
        JqiNCGXjkaMqEYFPOYCaW0qcYfl1: {
          nick: 'privateprinzesska',
          operatorId: 'THNDR',
          position: 6,
          rank: 6,
          value: 1112,
        },
        KaP60cM3xuVOG0sa0kVPo67yKVq1: {
          nick: 'duyduy',
          operatorId: 'THNDR',
          position: 25,
          rank: 25,
          value: 452,
        },
        LjAvwnY7DSb7FdzT7Xonp0ewjuy1: {
          nick: 'h1gher',
          operatorId: 'THNDR',
          position: 18,
          rank: 18,
          value: 626,
        },
        NHezp26RNOdWX1KZMgpCyzw57Mn1: {
          nick: 'ProfessorSyma',
          operatorId: 'THNDR',
          position: 9,
          rank: 9,
          value: 1079,
        },
        OBvLyuG4l3ecP4zQaah1naAnNpy1: {
          nick: 'WhiteGangsta',
          operatorId: 'THNDR',
          position: 54,
          rank: 54,
          value: 261,
        },
        SEBv7fxqZANK4o5EisBNm6Wjm0r2: {
          nick: 'Hustlegod666',
          operatorId: 'THNDR',
          position: 61,
          rank: 61,
          value: 223,
        },
        SZNpkP4YeYM6emUlJJcPuvlKJE72: {
          nick: 'Rhea',
          operatorId: 'THNDR',
          position: 93,
          rank: 93,
          value: 167,
        },
        TUiqA4Q6EaTCwRVJuYCzUDgvLSC3: {
          nick: 'Xtypicalboy',
          operatorId: 'THNDR',
          position: 45,
          rank: 45,
          value: 303,
        },
        Tl9dDwvCSjOjsKZQqB7eXv0Laho2: {
          nick: 'brotoshi',
          operatorId: 'THNDR',
          position: 48,
          rank: 48,
          value: 281,
        },
        TwgWSWsqIrdx27z1Hvlb0EEaB3u1: {
          nick: 'raim1',
          operatorId: 'THNDR',
          position: 58,
          rank: 58,
          value: 239,
        },
        UPAdHYrMNde83CQM1QbOPVo4i1o2: {
          nick: 'Bieganiec',
          operatorId: 'THNDR',
          position: 43,
          rank: 43,
          value: 306,
        },
        VQ21Q4670YhnSk3GrAM6pbLQ6kq2: {
          nick: 'MonkeyMan',
          operatorId: 'THNDR',
          position: 8,
          rank: 8,
          value: 1103,
        },
        VX0ESW2LEjdNEg1R1Wra4VvG7xj2: {
          nick: 'SlipperyDolphin',
          operatorId: 'THNDR',
          position: 80,
          rank: 80,
          value: 186,
        },
        WSQViTjAPtZzLcFl35AADFAaVmB2: {
          nick: 'Jimba',
          operatorId: 'THNDR',
          position: 78,
          rank: 78,
          value: 192,
        },
        WpE6NazvARfqiqxLhvBgCtrzHID3: {
          nick: 'Deborah',
          operatorId: 'THNDR',
          position: 71,
          rank: 70,
          value: 201,
        },
        YjPZOYpdJOYEhjQgeNmfORFUjqE3: {
          nick: 'kylieky',
          operatorId: 'THNDR',
          position: 44,
          rank: 44,
          value: 305,
        },
        Z8w76Fyin8hT5MtDJfl9YJ8qmoZ2: {
          nick: 'kheefleek ',
          operatorId: 'THNDR',
          position: 84,
          rank: 84,
          value: 181,
        },
        ZP1PfEawyDcVCtIwqCFuGuFmP1U2: {
          nick: 'la mera verga',
          operatorId: 'THNDR',
          position: 76,
          rank: 76,
          value: 193,
        },
        ZkoCf7kXVDfowrts5pSLfjNCVFr2: {
          nick: 'godneverdie',
          operatorId: 'THNDR',
          position: 38,
          rank: 38,
          value: 323,
        },
        aEQF5MSwwAPC0v1MTbbjs1vqskK2: {
          nick: 'tilin',
          operatorId: 'THNDR',
          position: 2,
          rank: 2,
          value: 2010,
        },
        'aefd3fb3-65ed-4832-a630-acb913053ffb': {
          nick: 'Lucas Hubbard',
          operatorId: 'speed',
          position: 98,
          rank: 98,
          value: 161,
        },
        boPrmOMP9NNdALE3UaYAPrqPvJs1: {
          nick: 'Arkhen',
          operatorId: 'THNDR',
          position: 46,
          rank: 46,
          value: 294,
        },
        'c07a5ee3-26a7-44eb-b0b2-f088df935edb': {
          nick: 'Dat Nguyen',
          operatorId: 'speed',
          position: 51,
          rank: 51,
          value: 271,
        },
        'c8e102a7-3b11-4749-a03f-f722828e27f5': {
          nick: 'Daniarmando',
          operatorId: 'telegram',
          position: 97,
          rank: 97,
          value: 162,
        },
        cLVJXQObd7Q7CTYRJT0asGIG4ub2: {
          nick: 'leokim',
          operatorId: 'THNDR',
          position: 31,
          rank: 31,
          value: 385,
        },
        ceeWs4u2PaMHUifqGrcjwtEPVpe2: {
          nick: 'Maco04',
          operatorId: 'THNDR',
          position: 59,
          rank: 59,
          value: 231,
        },
        cpe6vtDd1TYuxM7wwapCGPd5zMr2: {
          nick: 'Radentor',
          operatorId: 'THNDR',
          position: 19,
          rank: 19,
          value: 606,
        },
        'e466aec5-c2d8-4d4a-aa1d-b69b985c3f6a': {
          nick: 'justint24',
          operatorId: 'betopenly',
          position: 56,
          rank: 56,
          value: 256,
        },
        'e5bf14b2-6c34-4fe1-99bf-831b98c3860e': {
          nick: 'dasauce8063',
          operatorId: 'betopenly',
          position: 88,
          rank: 87,
          value: 173,
        },
        'ea5cf715-7efd-4b60-afc5-8e449ae842aa': {
          nick: 'kisjugbe',
          operatorId: 'betopenly',
          position: 34,
          rank: 34,
          value: 364,
        },
        'eaf6c455-0472-4a0a-9770-0b11878864e2': {
          nick: 'trodabaugh',
          operatorId: 'betopenly',
          position: 21,
          rank: 21,
          value: 573,
        },
        'ed515bf0-75ed-4319-a22c-7712aa182791': {
          nick: 'rgalexander216',
          operatorId: 'betopenly',
          position: 66,
          rank: 66,
          value: 209,
        },
        'f3bacf77-fae7-4598-b3b2-a47f6a692f82': {
          nick: 'Luzpurazo',
          operatorId: 'telegram',
          position: 99,
          rank: 98,
          value: 161,
        },
        'f84f0522-8325-4b53-903d-b04230e14eda': {
          nick: 'Rexdentron',
          operatorId: 'telegram',
          position: 30,
          rank: 30,
          value: 404,
        },
        fFUyVXARbnQduTEIEqAlbwn08eP2: {
          nick: 'PazZay',
          operatorId: 'THNDR',
          position: 28,
          rank: 28,
          value: 438,
        },
        'fcea4bc7-582a-4993-9b72-7b2d0a37c9ed': {
          nick: 'midamikx',
          operatorId: 'telegram',
          position: 75,
          rank: 75,
          value: 195,
        },
        gf1spz6Jmsg3wMycVm7RyMKERNs1: {
          nick: 'littleminer',
          operatorId: 'THNDR',
          position: 74,
          rank: 74,
          value: 198,
        },
        gfo53QJFheeg3czzp2zI6OuLFWk2: {
          nick: '1000 is not enough',
          operatorId: 'THNDR',
          position: 33,
          rank: 33,
          value: 371,
        },
        guB7L44EhvYyDhUqXU2LJqYkMyt1: {
          nick: 'guoy',
          operatorId: 'THNDR',
          position: 96,
          rank: 95,
          value: 164,
        },
        hxld3PnZksN6N7HFXHXZV2g45Sg2: {
          nick: 'eldiablobo',
          operatorId: 'THNDR',
          position: 83,
          rank: 81,
          value: 182,
        },
        iMRdj6gJwwbvW5TFgGrPyfE2K9V2: {
          nick: 'yeah eyae hayeah',
          operatorId: 'THNDR',
          position: 27,
          rank: 26,
          value: 451,
        },
        iSktZeq7olZipQvAsBwPQ0kVQCk1: {
          nick: 'kball',
          operatorId: 'THNDR',
          position: 24,
          rank: 24,
          value: 459,
        },
        j1Z1WPziqYXZmsCqL8RrS2C4ED32: {
          nick: 'COFFI',
          operatorId: 'THNDR',
          position: 32,
          rank: 31,
          value: 385,
        },
        lTrOWSqeYaS0liznnofgXOnqCgU2: {
          nick: 'Fery',
          operatorId: 'THNDR',
          position: 100,
          rank: 98,
          value: 161,
        },
        m71e9TEHcQVI6gNtKnOA9V8uKCc2: {
          nick: 'Nat',
          operatorId: 'THNDR',
          position: 20,
          rank: 20,
          value: 586,
        },
        meK5vW1SDdUv5ZK7idQyWHqXYKR2: {
          nick: 'wso18',
          operatorId: 'THNDR',
          position: 3,
          rank: 3,
          value: 1350,
        },
        nToQ1lWacwVaiZ10wmzaXUYd1dS2: {
          nick: 'gastongg5',
          operatorId: 'THNDR',
          position: 36,
          rank: 36,
          value: 345,
        },
        oEXGvwgloVSRJ7aqM48jRry0gp52: {
          nick: 'Lucky4aWhile',
          operatorId: 'THNDR',
          position: 53,
          rank: 53,
          value: 262,
        },
        pJEGDyOweoTEKlJ0NsALblBYgpb2: {
          nick: 'Diegote',
          operatorId: 'THNDR',
          position: 29,
          rank: 29,
          value: 412,
        },
        pNzsBfAMula1p9k6CutPq8EU7u92: {
          nick: 'whyiodda',
          operatorId: 'THNDR',
          position: 73,
          rank: 73,
          value: 199,
        },
        qRmDm0SvbuYwfg7o9OCGNP8oCkJ2: {
          nick: 'Lixeeer',
          operatorId: 'THNDR',
          position: 14,
          rank: 14,
          value: 787,
        },
        qTQo8HlhuuPhuzs0wum37pdDWTN2: {
          nick: 'miina',
          operatorId: 'THNDR',
          position: 62,
          rank: 62,
          value: 217,
        },
        qpgdvttycFQIv9fZJOIHGytNznO2: {
          nick: 'mwg',
          operatorId: 'THNDR',
          position: 13,
          rank: 13,
          value: 866,
        },
        rzGu7cLdufZu7neHj72ioj4lqmt2: {
          nick: 'harlsbishhh96',
          operatorId: 'THNDR',
          position: 87,
          rank: 87,
          value: 173,
        },
        s0Qlml5rUfftTdPvAOEfBeaGslT2: {
          nick: 'katie',
          operatorId: 'THNDR',
          position: 47,
          rank: 47,
          value: 292,
        },
        s8CuwoXVfKajUoHKYthX7Apvcz92: {
          nick: 'ralf',
          operatorId: 'THNDR',
          position: 52,
          rank: 52,
          value: 267,
        },
        sU0QcGkr0Pe60tUwItFdb1STzgn1: {
          nick: 'jennadeea',
          operatorId: 'THNDR',
          position: 79,
          rank: 78,
          value: 192,
        },
        tjXxUidlZwbToR6S47KozoKBezC2: {
          nick: 'cowmaster',
          operatorId: 'THNDR',
          position: 57,
          rank: 57,
          value: 254,
        },
        tuYwO79Tp8UtcStvinSrcRJ4lT02: {
          nick: 'BFC1903',
          operatorId: 'THNDR',
          position: 64,
          rank: 64,
          value: 212,
        },
        uwDvADYKOLNmQJ9WX83SXUmjA0i1: {
          nick: 'Lavalava',
          operatorId: 'THNDR',
          position: 42,
          rank: 42,
          value: 308,
        },
        vfrqXxPqY9WZPSbem0Clz8vyRTn1: {
          nick: 'passie',
          operatorId: 'THNDR',
          position: 5,
          rank: 5,
          value: 1119,
        },
        wwACEIvG3LWbirz1Axs5XM0RDyh2: {
          nick: 'DemonaZA',
          operatorId: 'THNDR',
          position: 37,
          rank: 37,
          value: 333,
        },
      },
    },
  },
};

export const LEADERBOARD_MOSTMONEY_1DAY = {
  status: 200,
  body: {
    status: 200,
    msg: 'Leaderboard',
    data: {
      lastUpdated: 1741615204776,
      leaderboardData: {
        '0ANFbHbkKXgv2ss6NJ1oLB5jxli2': {
          nick: 'Woo',
          operatorId: 'THNDR',
          position: 90,
          rank: 72,
          value: 0.5,
        },
        '1990c411-0090-4779-abe9-f76c9ef06943': {
          nick: 'Duncan Rushing',
          operatorId: 'speed',
          position: 84,
          rank: 72,
          value: 0.5,
        },
        '2UXKtKldCtUSajNQMrr0Em5hvfR2': {
          nick: 'Dat Nguyen',
          operatorId: 'THNDR',
          position: 61,
          rank: 61,
          value: 1,
        },
        '2eb3ca69-4b96-4f6c-9b35-7657d263a419': {
          nick: 'p00kiebaby',
          operatorId: 'telegram',
          position: 67,
          rank: 61,
          value: 1,
        },
        '2f9ccb6c-fea1-46c4-bcb3-0214c4abaf04': {
          nick: 'chessfan777',
          operatorId: 'betopenly',
          position: 13,
          rank: 13,
          value: 14,
        },
        '3250050e-ad3a-4d06-b779-bcc1b532dfe0': {
          nick: 'PazZayy',
          operatorId: 'telegram',
          position: 4,
          rank: 4,
          value: 80,
        },
        '35044969-6f82-4ea6-8773-fbeee4c03544': {
          nick: 'Shahryar Eslami Moghaddam',
          operatorId: 'speed',
          position: 88,
          rank: 72,
          value: 0.5,
        },
        '42280e00-0e2d-41a9-aaac-05e9c0b84826': {
          nick: 'Passiveuro',
          operatorId: 'telegram',
          position: 59,
          rank: 54,
          value: 1.5,
        },
        '42f20c5c-c75a-4515-97c0-98ba62487d26': {
          nick: 'Tracey Morrison',
          operatorId: 'speed',
          position: 10,
          rank: 10,
          value: 25,
        },
        '46938e4c-bc24-45cd-9b93-460eef349086': {
          nick: 'Neshdan',
          operatorId: 'telegram',
          position: 22,
          rank: 22,
          value: 7,
        },
        '46PjSe8BRbUKqhUFefslwGWDTzI2': {
          nick: 'ChickieDee',
          operatorId: 'THNDR',
          position: 63,
          rank: 61,
          value: 1,
        },
        '471ed25d-5f49-43fa-8168-dc60aca5bb0a': {
          nick: 'Brokk Beam',
          operatorId: 'speed',
          position: 76,
          rank: 72,
          value: 0.5,
        },
        '4I7HWcHGprVlEzbKOdrxCKAp49x1': {
          nick: 'Kendrab23',
          operatorId: 'THNDR',
          position: 24,
          rank: 22,
          value: 7,
        },
        '4W29W8plWNgZb3jFon56OFgNSHJ3': {
          nick: 'suckmydiesel',
          operatorId: 'THNDR',
          position: 64,
          rank: 61,
          value: 1,
        },
        '4aa0ed64-17d4-42ac-80dc-9276c6b261e5': {
          nick: 'James Ferrell',
          operatorId: 'speed',
          position: 48,
          rank: 47,
          value: 2,
        },
        '5QfuKqzJ77cjIzIMpbirJPKig8w2': {
          nick: 'BtceXMasteR',
          operatorId: 'THNDR',
          position: 5,
          rank: 5,
          value: 63,
        },
        '5d54f9d2-e7d6-41f7-a60d-4469af688ef3': {
          nick: 'Samuel Yilak',
          operatorId: 'speed',
          position: 99,
          rank: 72,
          value: 0.5,
        },
        '5sFdUGZOOnZEDRkw2WXAeBXdsmF2': {
          nick: 'savinghumanity',
          operatorId: 'THNDR',
          position: 81,
          rank: 72,
          value: 0.5,
        },
        '699f6481-94c1-4a51-9680-c3b18abcac8c': {
          nick: 'Airavat01',
          operatorId: 'telegram',
          position: 89,
          rank: 72,
          value: 0.5,
        },
        '6f9538d7-19ff-427d-b910-070f347f5785': {
          nick: 'Paul Sedov',
          operatorId: 'speed',
          position: 58,
          rank: 54,
          value: 1.5,
        },
        '71fcc902-113d-4a36-8f6d-3b7e9f84d50c': {
          nick: 'OmarCripto86',
          operatorId: 'telegram',
          position: 17,
          rank: 17,
          value: 10.5,
        },
        '754a6395-04f9-4d0d-a9fc-4cef356edae3': {
          nick: 'lukep2002',
          operatorId: 'betopenly',
          position: 28,
          rank: 26,
          value: 6,
        },
        '86c32412-7374-49d1-a9d7-0ecfb4630127': {
          nick: 'Dheyaisgavidia',
          operatorId: 'telegram',
          position: 45,
          rank: 44,
          value: 2.5,
        },
        '877628a5-7dae-445b-b698-567459c035a9': {
          nick: 'Kevin Zuhaus',
          operatorId: 'speed',
          position: 97,
          rank: 72,
          value: 0.5,
        },
        '892383d9-10e4-40bd-bdda-922b296f9bec': {
          nick: 'Kody Laurent',
          operatorId: 'speed',
          position: 35,
          rank: 32,
          value: 5,
        },
        '8Jdg8uC8SGP0T5divdQe1WxPobN2': {
          nick: 'sanyeo',
          operatorId: 'THNDR',
          position: 82,
          rank: 72,
          value: 0.5,
        },
        '8a70ecfe-7dd7-47c9-bc63-d9a38f3dc7ed': {
          nick: 'JeyG Gluch',
          operatorId: 'speed',
          position: 41,
          rank: 40,
          value: 3,
        },
        '980098ad-a54b-49d9-8717-13926a770425': {
          nick: 'William Hecimovich',
          operatorId: 'speed',
          position: 71,
          rank: 61,
          value: 1,
        },
        '9Y7FojpTt0XkYW1RoufrOvV2sgI2': {
          nick: 'quite ',
          operatorId: 'THNDR',
          position: 38,
          rank: 38,
          value: 3.5,
        },
        '9oPTDONwyvXcifEZO2BJG9rbZeP2': {
          nick: 'serberuz',
          operatorId: 'THNDR',
          position: 12,
          rank: 12,
          value: 15,
        },
        A8OIhvNl2eV87S7o8RmrOOr2eLl2: {
          nick: 'DabroX',
          operatorId: 'THNDR',
          position: 42,
          rank: 40,
          value: 3,
        },
        AR1fJqJZqLSHFt9UtBQELu9J2C42: {
          nick: 'GA99Y',
          operatorId: 'THNDR',
          position: 31,
          rank: 29,
          value: 5.5,
        },
        AS7GV1EVBDQayArH5bPzaAXfMSs1: {
          nick: 'larame413',
          operatorId: 'THNDR',
          position: 51,
          rank: 47,
          value: 2,
        },
        B7W0BEKPOFfKcyuxHBO4S2tNqIU2: {
          nick: 'RuegoOhYXZqqh7',
          operatorId: 'THNDR',
          position: 8,
          rank: 8,
          value: 35,
        },
        BIMH6yaAn7NapBRCl03x7na5Ji73: {
          nick: 'random39',
          operatorId: 'THNDR',
          position: 50,
          rank: 47,
          value: 2,
        },
        BUPhdpHpquSC3I3EPnRiisQHAhh1: {
          nick: 'thomsolodev',
          operatorId: 'THNDR',
          position: 53,
          rank: 47,
          value: 2,
        },
        DqOwlFWF9pgD6V3Rf2iZH8SYhW02: {
          nick: 'boby',
          operatorId: 'THNDR',
          position: 92,
          rank: 72,
          value: 0.5,
        },
        DquvTqsjUWhHmfwDxweisAaVbSs1: {
          nick: 'Jason B',
          operatorId: 'THNDR',
          position: 21,
          rank: 21,
          value: 9,
        },
        DuTSHjO8XrZBLxkoPt6v6x6Xp9n1: {
          nick: '1ll',
          operatorId: 'THNDR',
          position: 7,
          rank: 7,
          value: 40,
        },
        E3PPyFdgU2cCYUQ02Gk35OHSHbo2: {
          nick: 'richmondtina',
          operatorId: 'THNDR',
          position: 9,
          rank: 9,
          value: 27,
        },
        EH28THF8y1gU8fM89ykJJkmYP9T2: {
          nick: 'Rexdentron',
          operatorId: 'THNDR',
          position: 1,
          rank: 1,
          value: 497.5,
        },
        Em3mJ9Y8ePdPLtQZnJ6prqAWxWf2: {
          nick: 'lala ',
          operatorId: 'THNDR',
          position: 54,
          rank: 54,
          value: 1.5,
        },
        J9krVBUj4zdkwNDqPWv913KMsFY2: {
          nick: 'jahdidit',
          operatorId: 'THNDR',
          position: 49,
          rank: 47,
          value: 2,
        },
        JqiNCGXjkaMqEYFPOYCaW0qcYfl1: {
          nick: 'privateprinzesska',
          operatorId: 'THNDR',
          position: 30,
          rank: 29,
          value: 5.5,
        },
        MqL8KlOXGNajWFThPljAFpLiipX2: {
          nick: 'Running',
          operatorId: 'THNDR',
          position: 39,
          rank: 38,
          value: 3.5,
        },
        NVaHlioPCZM4HqkMbPIO9MufcGN2: {
          nick: 'jas0615',
          operatorId: 'THNDR',
          position: 87,
          rank: 72,
          value: 0.5,
        },
        PSc4nkg5E8MmM8lzeNKCgYV1bOY2: {
          nick: 'Vinybergamo',
          operatorId: 'THNDR',
          position: 95,
          rank: 72,
          value: 0.5,
        },
        Qlh5bdY7u6chZ8ttXuAqjUvaw323: {
          nick: 'SEKAI',
          operatorId: 'THNDR',
          position: 55,
          rank: 54,
          value: 1.5,
        },
        RwWxnCZrXVed2Unj4EbINAQ55TC3: {
          nick: 'uwildie2',
          operatorId: 'THNDR',
          position: 83,
          rank: 72,
          value: 0.5,
        },
        T3aOJwMSzjQsfDu0TzTLZFDfE6G2: {
          nick: 'Taetay420 ',
          operatorId: 'THNDR',
          position: 79,
          rank: 72,
          value: 0.5,
        },
        TjqSO6wWUPgRhAHkk6uKf0XC5ve2: {
          nick: 'gjoy ali',
          operatorId: 'THNDR',
          position: 29,
          rank: 29,
          value: 5.5,
        },
        UPAdHYrMNde83CQM1QbOPVo4i1o2: {
          nick: 'Bieganiec',
          operatorId: 'THNDR',
          position: 86,
          rank: 72,
          value: 0.5,
        },
        VQ21Q4670YhnSk3GrAM6pbLQ6kq2: {
          nick: 'MonkeyMan',
          operatorId: 'THNDR',
          position: 23,
          rank: 22,
          value: 7,
        },
        VQCcQDtIKgTuJb8S0zBo7TARmxl2: {
          nick: 'kawaikea',
          operatorId: 'THNDR',
          position: 15,
          rank: 15,
          value: 12.5,
        },
        XVIggAUsLugui5MBMzna8bOmIqK2: {
          nick: 'MollyQue',
          operatorId: 'THNDR',
          position: 74,
          rank: 72,
          value: 0.5,
        },
        Y9WNeztb3UNdueuYgKSDObJftua2: {
          nick: 'moonp1e88 ',
          operatorId: 'THNDR',
          position: 62,
          rank: 61,
          value: 1,
        },
        Z8w76Fyin8hT5MtDJfl9YJ8qmoZ2: {
          nick: 'kheefleek ',
          operatorId: 'THNDR',
          position: 52,
          rank: 47,
          value: 2,
        },
        Zaqo7osp1fgDHKV1xqq7vRAzl6k2: {
          nick: 'maxpow',
          operatorId: 'THNDR',
          position: 40,
          rank: 40,
          value: 3,
        },
        ZkoCf7kXVDfowrts5pSLfjNCVFr2: {
          nick: 'godneverdie',
          operatorId: 'THNDR',
          position: 6,
          rank: 6,
          value: 58.5,
        },
        'a0dbf0bb-65bf-442a-81e4-f04d6de319e8': {
          nick: 'player42964',
          operatorId: 'telegram',
          position: 94,
          rank: 72,
          value: 0.5,
        },
        'a9863cef-a685-42c3-872b-aea054ad02d8': {
          nick: 'Jsurkes',
          operatorId: 'telegram',
          position: 96,
          rank: 72,
          value: 0.5,
        },
        aQ4boibSzZgJhL1hr0YQ8dTaFEX2: {
          nick: 'spacekais',
          operatorId: 'THNDR',
          position: 34,
          rank: 32,
          value: 5,
        },
        'aefd3fb3-65ed-4832-a630-acb913053ffb': {
          nick: 'Lucas Hubbard',
          operatorId: 'speed',
          position: 32,
          rank: 32,
          value: 5,
        },
        'bb036b78-6a35-45ed-b87e-481cd6032d2c': {
          nick: 'Palim778',
          operatorId: 'telegram',
          position: 73,
          rank: 72,
          value: 0.5,
        },
        btN5UEmd1wVf9DSPFLF2GigzaP03: {
          nick: 'theMightynah',
          operatorId: 'THNDR',
          position: 14,
          rank: 14,
          value: 13,
        },
        cLVJXQObd7Q7CTYRJT0asGIG4ub2: {
          nick: 'leokim',
          operatorId: 'THNDR',
          position: 36,
          rank: 36,
          value: 4.5,
        },
        'd3fad122-0682-41fd-8f55-0f5e6460bed5': {
          nick: 'OSWIL ADONIYAS SOTO REVOLORIO',
          operatorId: 'speed',
          position: 56,
          rank: 54,
          value: 1.5,
        },
        'd70cd470-e589-4075-9a76-42e20da006cd': {
          nick: 'player99966',
          operatorId: 'telegram',
          position: 19,
          rank: 18,
          value: 9.5,
        },
        'd8c132b6-b0dd-4b2c-a54b-d0b3bd214169': {
          nick: 'Luis Enrique Hernandez',
          operatorId: 'speed',
          position: 66,
          rank: 61,
          value: 1,
        },
        'ddb64a25-32bc-4d73-9984-9f23fad233b6': {
          nick: 'justthatdude22',
          operatorId: 'speed',
          position: 27,
          rank: 26,
          value: 6,
        },
        'e46d0efc-bedb-41d7-ab9b-7bcc90c190e2': {
          nick: 'Redi 5A',
          operatorId: 'speed',
          position: 100,
          rank: 72,
          value: 0.5,
        },
        'e678f4b3-3945-4865-898e-2d39f4a23595': {
          nick: 'MFnOGMasterD',
          operatorId: 'telegram',
          position: 72,
          rank: 72,
          value: 0.5,
        },
        'e800b00b-76d7-484c-8799-9aea34102c5b': {
          nick: 'Robert Titze',
          operatorId: 'speed',
          position: 69,
          rank: 61,
          value: 1,
        },
        eOAV5NVHQmVnL3Pl6fryQ7C3O0C3: {
          nick: 'jeaclaphi',
          operatorId: 'THNDR',
          position: 60,
          rank: 54,
          value: 1.5,
        },
        'ebba3541-dddd-402c-a490-a187f976615f': {
          nick: 'Vincent Munoz',
          operatorId: 'speed',
          position: 93,
          rank: 72,
          value: 0.5,
        },
        'ed515bf0-75ed-4319-a22c-7712aa182791': {
          nick: 'rgalexander216',
          operatorId: 'betopenly',
          position: 2,
          rank: 2,
          value: 110,
        },
        'f067b3f1-3620-4ea9-ac84-18de42911edf': {
          nick: 'neckfoot',
          operatorId: 'betopenly',
          position: 26,
          rank: 26,
          value: 6,
        },
        'f52402da-f5b0-41cc-bb18-1fb7d8164dbe': {
          nick: 'player66627',
          operatorId: 'telegram',
          position: 70,
          rank: 61,
          value: 1,
        },
        'f5d3c9b7-0bd9-46ae-85a7-d362f5c9cd6e': {
          nick: 'Jessie Riddle',
          operatorId: 'speed',
          position: 78,
          rank: 72,
          value: 0.5,
        },
        'f84f0522-8325-4b53-903d-b04230e14eda': {
          nick: 'Rexdentron',
          operatorId: 'telegram',
          position: 3,
          rank: 3,
          value: 82.5,
        },
        fXFhQ9zDqwZhaqoJTzYSWDoMjn52: {
          nick: 'player2568',
          operatorId: 'THNDR',
          position: 85,
          rank: 72,
          value: 0.5,
        },
        'fbb1c655-9a77-4904-b8d5-1aa516a35127': {
          nick: 'Jeremy Johnson',
          operatorId: 'speed',
          position: 44,
          rank: 44,
          value: 2.5,
        },
        'fe050371-7080-4d65-b911-1ea479d242ae': {
          nick: 'Chiman Jerome',
          operatorId: 'speed',
          position: 57,
          rank: 54,
          value: 1.5,
        },
        gf1spz6Jmsg3wMycVm7RyMKERNs1: {
          nick: 'littleminer',
          operatorId: 'THNDR',
          position: 37,
          rank: 36,
          value: 4.5,
        },
        ixSu7EbpUhbswPZZuRY8cTzoBwy2: {
          nick: 'mailla888',
          operatorId: 'THNDR',
          position: 43,
          rank: 40,
          value: 3,
        },
        m71e9TEHcQVI6gNtKnOA9V8uKCc2: {
          nick: 'Nat',
          operatorId: 'THNDR',
          position: 46,
          rank: 44,
          value: 2.5,
        },
        meK5vW1SDdUv5ZK7idQyWHqXYKR2: {
          nick: 'wso18',
          operatorId: 'THNDR',
          position: 20,
          rank: 18,
          value: 9.5,
        },
        nToQ1lWacwVaiZ10wmzaXUYd1dS2: {
          nick: 'gastongg5',
          operatorId: 'THNDR',
          position: 68,
          rank: 61,
          value: 1,
        },
        p3ygX7hM2ySITzvqblh5aQv7lxz1: {
          nick: 'prettylady85 ',
          operatorId: 'THNDR',
          position: 80,
          rank: 72,
          value: 0.5,
        },
        pJEGDyOweoTEKlJ0NsALblBYgpb2: {
          nick: 'Diegote',
          operatorId: 'THNDR',
          position: 18,
          rank: 18,
          value: 9.5,
        },
        qENvX9vRToPBnFcTB5d69zq8Vog1: {
          nick: 'b3snakes',
          operatorId: 'THNDR',
          position: 47,
          rank: 47,
          value: 2,
        },
        qpgdvttycFQIv9fZJOIHGytNznO2: {
          nick: 'mwg',
          operatorId: 'THNDR',
          position: 25,
          rank: 22,
          value: 7,
        },
        r9pPvrYvbWZEo2ZFtXnmEEjyifN2: {
          nick: 'DeeRugs',
          operatorId: 'THNDR',
          position: 75,
          rank: 72,
          value: 0.5,
        },
        rzGu7cLdufZu7neHj72ioj4lqmt2: {
          nick: 'harlsbishhh96',
          operatorId: 'THNDR',
          position: 91,
          rank: 72,
          value: 0.5,
        },
        s0Qlml5rUfftTdPvAOEfBeaGslT2: {
          nick: 'katie',
          operatorId: 'THNDR',
          position: 11,
          rank: 11,
          value: 18.5,
        },
        tR64VxeOkaPQpJTmzWFYWGWe35k2: {
          nick: 'Scammer',
          operatorId: 'THNDR',
          position: 16,
          rank: 15,
          value: 12.5,
        },
        vyjpq2S6S6YSRu5kaBl6OYR4ae42: {
          nick: 'CryptoMeow',
          operatorId: 'THNDR',
          position: 98,
          rank: 72,
          value: 0.5,
        },
        wwACEIvG3LWbirz1Axs5XM0RDyh2: {
          nick: 'DemonaZA',
          operatorId: 'THNDR',
          position: 77,
          rank: 72,
          value: 0.5,
        },
        x9VO8NZNT9QRnpxpKImdBk1gtVi1: {
          nick: 'Twiztidcrypto',
          operatorId: 'THNDR',
          position: 33,
          rank: 32,
          value: 5,
        },
        xzAT9NH68HPeTE1vmEjulAsl1X33: {
          nick: 'BlockRock',
          operatorId: 'THNDR',
          position: 65,
          rank: 61,
          value: 1,
        },
      },
    },
  },
};

export const LEADERBOARD_MOSTMONEY_7DAY = {
  status: 200,
  body: {
    status: 200,
    msg: 'Leaderboard',
    data: {
      lastUpdated: 1741615204776,
      leaderboardData: {
        '0ANFbHbkKXgv2ss6NJ1oLB5jxli2': {
          nick: 'Woo',
          operatorId: 'THNDR',
          position: 81,
          rank: 81,
          value: 7,
        },
        '0fc87d3c-b113-471d-b1b8-fcb8ffb0c147': {
          nick: 'player26129',
          operatorId: 'telegram',
          position: 38,
          rank: 36,
          value: 25,
        },
        '1d9f64b7-eeaa-4d25-9335-bb701bebfe70': {
          nick: 'conch',
          operatorId: 'betopenly',
          position: 6,
          rank: 6,
          value: 210,
        },
        '1dacdc28-62c9-46e5-97bb-a8695195f333': {
          nick: 'Pedro Oliveira',
          operatorId: 'speed',
          position: 50,
          rank: 50,
          value: 16.5,
        },
        '21902c78-d99e-45e7-b050-f1ac3e37807b': {
          nick: 'Flemmon Cochran',
          operatorId: 'speed',
          position: 77,
          rank: 76,
          value: 7.5,
        },
        '295k0YwRKFSfT9V2RYC3S10FgCk2': {
          nick: 'Ziggy9044',
          operatorId: 'THNDR',
          position: 73,
          rank: 72,
          value: 8,
        },
        '2OG2GPZLspQajQxzIcBsTvVy6XH2': {
          nick: 'Rai',
          operatorId: 'THNDR',
          position: 57,
          rank: 57,
          value: 12.5,
        },
        '2f695159-4099-4b89-b38e-1468dd7cfc95': {
          nick: 'jbrug420',
          operatorId: 'betopenly',
          position: 5,
          rank: 5,
          value: 240,
        },
        '2f9ccb6c-fea1-46c4-bcb3-0214c4abaf04': {
          nick: 'chessfan777',
          operatorId: 'betopenly',
          position: 16,
          rank: 16,
          value: 74,
        },
        '2qsJppEJzRdvljATq5tYTtdAeyF3': {
          nick: 'AngryKat1 ',
          operatorId: 'THNDR',
          position: 93,
          rank: 91,
          value: 5.5,
        },
        '3250050e-ad3a-4d06-b779-bcc1b532dfe0': {
          nick: 'PazZayy',
          operatorId: 'telegram',
          position: 2,
          rank: 2,
          value: 790,
        },
        '42f20c5c-c75a-4515-97c0-98ba62487d26': {
          nick: 'Tracey Morrison',
          operatorId: 'speed',
          position: 37,
          rank: 36,
          value: 25,
        },
        '46938e4c-bc24-45cd-9b93-460eef349086': {
          nick: 'Neshdan',
          operatorId: 'telegram',
          position: 22,
          rank: 22,
          value: 48,
        },
        '4I7HWcHGprVlEzbKOdrxCKAp49x1': {
          nick: 'Kendrab23',
          operatorId: 'THNDR',
          position: 32,
          rank: 32,
          value: 28,
        },
        '4W29W8plWNgZb3jFon56OFgNSHJ3': {
          nick: 'suckmydiesel',
          operatorId: 'THNDR',
          position: 49,
          rank: 49,
          value: 17,
        },
        '4aa0ed64-17d4-42ac-80dc-9276c6b261e5': {
          nick: 'James Ferrell',
          operatorId: 'speed',
          position: 24,
          rank: 24,
          value: 46,
        },
        '5QfuKqzJ77cjIzIMpbirJPKig8w2': {
          nick: 'BtceXMasteR',
          operatorId: 'THNDR',
          position: 14,
          rank: 14,
          value: 90.5,
        },
        '5e4bc49a-367e-42ac-aea5-612e41f33d2b': {
          nick: 'a muse',
          operatorId: 'speed',
          position: 78,
          rank: 76,
          value: 7.5,
        },
        '6788efd1-2cef-453f-ae08-53a067ab3c76': {
          nick: 'Georgii LupuliAk',
          operatorId: 'speed',
          position: 52,
          rank: 51,
          value: 15,
        },
        '6Fm0l4fZNiY7nFsqEOnmWdOWvEk1': {
          nick: 'kekiel0021300',
          operatorId: 'THNDR',
          position: 30,
          rank: 30,
          value: 33,
        },
        '6dmlAb7aL8gTqWPDM82RHV5ppPB2': {
          nick: 'Luffy96 ',
          operatorId: 'THNDR',
          position: 99,
          rank: 91,
          value: 5.5,
        },
        '6tBeqBz9iNS6I5MIGK6arVhuLOX2': {
          nick: 'We444072889',
          operatorId: 'THNDR',
          position: 66,
          rank: 66,
          value: 9,
        },
        '70027afc-c3fa-4933-b810-fe0b2167a24a': {
          nick: 'Lucas Henssler',
          operatorId: 'speed',
          position: 79,
          rank: 76,
          value: 7.5,
        },
        '71fcc902-113d-4a36-8f6d-3b7e9f84d50c': {
          nick: 'OmarCripto86',
          operatorId: 'telegram',
          position: 11,
          rank: 11,
          value: 110,
        },
        '754a6395-04f9-4d0d-a9fc-4cef356edae3': {
          nick: 'lukep2002',
          operatorId: 'betopenly',
          position: 25,
          rank: 25,
          value: 42,
        },
        '791ac21c-bc5b-4f2a-9e44-11dd2b672bac': {
          nick: 'Roneil Cayetano',
          operatorId: 'speed',
          position: 89,
          rank: 89,
          value: 6,
        },
        '7hJKmzdLguYHE8XsshEA1t6xLCM2': {
          nick: 'Maco0404',
          operatorId: 'THNDR',
          position: 12,
          rank: 12,
          value: 98,
        },
        '7iy1eIPdxxZkmVFi9IcNsIXUc3x1': {
          nick: 'ww815',
          operatorId: 'THNDR',
          position: 26,
          rank: 25,
          value: 42,
        },
        '7kFibKihfwcOikCCBsFDduclW2C3': {
          nick: 'jeondongcheol',
          operatorId: 'THNDR',
          position: 74,
          rank: 72,
          value: 8,
        },
        '816b27ed-1c8d-4b92-a9b9-e1da8ff72f72': {
          nick: 'Connor Anderson',
          operatorId: 'speed',
          position: 97,
          rank: 91,
          value: 5.5,
        },
        '877628a5-7dae-445b-b698-567459c035a9': {
          nick: 'Kevin Zuhaus',
          operatorId: 'speed',
          position: 92,
          rank: 91,
          value: 5.5,
        },
        '8Ab45eKYi9af6P2kJ20XrzR9HoL2': {
          nick: 'Radev',
          operatorId: 'THNDR',
          position: 96,
          rank: 91,
          value: 5.5,
        },
        '8Jdg8uC8SGP0T5divdQe1WxPobN2': {
          nick: 'sanyeo',
          operatorId: 'THNDR',
          position: 100,
          rank: 100,
          value: 5,
        },
        '9d9d67d7-88c0-4c96-b5d3-03d0d7cea8a8': {
          nick: 'Farshad Hajinejad',
          operatorId: 'speed',
          position: 55,
          rank: 55,
          value: 13.5,
        },
        '9oPTDONwyvXcifEZO2BJG9rbZeP2': {
          nick: 'serberuz',
          operatorId: 'THNDR',
          position: 51,
          rank: 51,
          value: 15,
        },
        A8OIhvNl2eV87S7o8RmrOOr2eLl2: {
          nick: 'DabroX',
          operatorId: 'THNDR',
          position: 41,
          rank: 39,
          value: 23.5,
        },
        AR1fJqJZqLSHFt9UtBQELu9J2C42: {
          nick: 'GA99Y',
          operatorId: 'THNDR',
          position: 69,
          rank: 69,
          value: 8.5,
        },
        B7W0BEKPOFfKcyuxHBO4S2tNqIU2: {
          nick: 'RuegoOhYXZqqh7',
          operatorId: 'THNDR',
          position: 15,
          rank: 15,
          value: 78.5,
        },
        BIMH6yaAn7NapBRCl03x7na5Ji73: {
          nick: 'random39',
          operatorId: 'THNDR',
          position: 44,
          rank: 44,
          value: 19.5,
        },
        BXVUCyEqCpXrcUki8yfi54KGnsK2: {
          nick: 'ryguy',
          operatorId: 'THNDR',
          position: 80,
          rank: 76,
          value: 7.5,
        },
        DDvKjZX7HJcwzoE5pg3NfjAERIv1: {
          nick: 'PrestonsGirl ',
          operatorId: 'THNDR',
          position: 70,
          rank: 69,
          value: 8.5,
        },
        DquvTqsjUWhHmfwDxweisAaVbSs1: {
          nick: 'Jason B',
          operatorId: 'THNDR',
          position: 60,
          rank: 60,
          value: 11,
        },
        DuTSHjO8XrZBLxkoPt6v6x6Xp9n1: {
          nick: '1ll',
          operatorId: 'THNDR',
          position: 21,
          rank: 21,
          value: 50,
        },
        E3PPyFdgU2cCYUQ02Gk35OHSHbo2: {
          nick: 'richmondtina',
          operatorId: 'THNDR',
          position: 33,
          rank: 33,
          value: 27,
        },
        E8xWOaODAmdoTjE9ybmBf7KRqYF3: {
          nick: 'Ondracoin33 ',
          operatorId: 'THNDR',
          position: 67,
          rank: 66,
          value: 9,
        },
        EH28THF8y1gU8fM89ykJJkmYP9T2: {
          nick: 'Rexdentron',
          operatorId: 'THNDR',
          position: 1,
          rank: 1,
          value: 1938.5,
        },
        Fzx6iXUiHDWJ71nrI90ZdY1wZNr2: {
          nick: 'orangepillee',
          operatorId: 'THNDR',
          position: 75,
          rank: 72,
          value: 8,
        },
        HSvrg5cGIjRayV4leACZIuI0mVx1: {
          nick: 'Roseline292',
          operatorId: 'THNDR',
          position: 59,
          rank: 58,
          value: 11.5,
        },
        HU69q4yyxYhJ78MRS3trLV63UUT2: {
          nick: 'sleekhamster',
          operatorId: 'THNDR',
          position: 86,
          rank: 81,
          value: 7,
        },
        JQCDZLR2P3fGQNKEQvUpF5Zc7if2: {
          nick: 'R aven',
          operatorId: 'THNDR',
          position: 98,
          rank: 91,
          value: 5.5,
        },
        JqiNCGXjkaMqEYFPOYCaW0qcYfl1: {
          nick: 'privateprinzesska',
          operatorId: 'THNDR',
          position: 20,
          rank: 20,
          value: 58.5,
        },
        LhoQSyiO1ZPeJrQSgHMXxDhOshw1: {
          nick: 'Louie22',
          operatorId: 'THNDR',
          position: 29,
          rank: 29,
          value: 37.5,
        },
        S1CP9f9tTHYHiFysaphIIetuzHW2: {
          nick: 'ogsythses',
          operatorId: 'THNDR',
          position: 53,
          rank: 53,
          value: 14.5,
        },
        SZNpkP4YeYM6emUlJJcPuvlKJE72: {
          nick: 'Rhea',
          operatorId: 'THNDR',
          position: 42,
          rank: 42,
          value: 22.5,
        },
        TUiqA4Q6EaTCwRVJuYCzUDgvLSC3: {
          nick: 'Xtypicalboy',
          operatorId: 'THNDR',
          position: 46,
          rank: 46,
          value: 19,
        },
        Tca2vWT3mqUKzfPjSCh3KkRgwf83: {
          nick: 'ashelk12',
          operatorId: 'THNDR',
          position: 65,
          rank: 65,
          value: 10,
        },
        TjqSO6wWUPgRhAHkk6uKf0XC5ve2: {
          nick: 'gjoy ali',
          operatorId: 'THNDR',
          position: 91,
          rank: 91,
          value: 5.5,
        },
        VQ21Q4670YhnSk3GrAM6pbLQ6kq2: {
          nick: 'MonkeyMan',
          operatorId: 'THNDR',
          position: 7,
          rank: 7,
          value: 169,
        },
        VQCcQDtIKgTuJb8S0zBo7TARmxl2: {
          nick: 'kawaikea',
          operatorId: 'THNDR',
          position: 36,
          rank: 36,
          value: 25,
        },
        Yvi8ALOpPrWW86pg85iX6O7xd493: {
          nick: 'peterson3223',
          operatorId: 'THNDR',
          position: 94,
          rank: 91,
          value: 5.5,
        },
        Z8w76Fyin8hT5MtDJfl9YJ8qmoZ2: {
          nick: 'kheefleek ',
          operatorId: 'THNDR',
          position: 62,
          rank: 60,
          value: 11,
        },
        ZMTLpjA302MAfCMB2ZUdHuvAlBp2: {
          nick: 'spideman',
          operatorId: 'THNDR',
          position: 84,
          rank: 81,
          value: 7,
        },
        Zaqo7osp1fgDHKV1xqq7vRAzl6k2: {
          nick: 'maxpow',
          operatorId: 'THNDR',
          position: 31,
          rank: 31,
          value: 29,
        },
        ZkoCf7kXVDfowrts5pSLfjNCVFr2: {
          nick: 'godneverdie',
          operatorId: 'THNDR',
          position: 8,
          rank: 8,
          value: 141.5,
        },
        'a1bafd95-f9c1-48e3-b2d0-1bd807764685': {
          nick: 'ali marada',
          operatorId: 'speed',
          position: 87,
          rank: 87,
          value: 6.5,
        },
        'a9863cef-a685-42c3-872b-aea054ad02d8': {
          nick: 'Jsurkes',
          operatorId: 'telegram',
          position: 63,
          rank: 60,
          value: 11,
        },
        aQ4boibSzZgJhL1hr0YQ8dTaFEX2: {
          nick: 'spacekais',
          operatorId: 'THNDR',
          position: 48,
          rank: 47,
          value: 18,
        },
        'aefd3fb3-65ed-4832-a630-acb913053ffb': {
          nick: 'Lucas Hubbard',
          operatorId: 'speed',
          position: 27,
          rank: 27,
          value: 41,
        },
        btN5UEmd1wVf9DSPFLF2GigzaP03: {
          nick: 'theMightynah',
          operatorId: 'THNDR',
          position: 56,
          rank: 56,
          value: 13,
        },
        cLVJXQObd7Q7CTYRJT0asGIG4ub2: {
          nick: 'leokim',
          operatorId: 'THNDR',
          position: 34,
          rank: 34,
          value: 26,
        },
        ceeWs4u2PaMHUifqGrcjwtEPVpe2: {
          nick: 'Maco04',
          operatorId: 'THNDR',
          position: 19,
          rank: 19,
          value: 68.5,
        },
        'd70cd470-e589-4075-9a76-42e20da006cd': {
          nick: 'player99966',
          operatorId: 'telegram',
          position: 40,
          rank: 39,
          value: 23.5,
        },
        d8CLFt4yg8VKrztSQGBloGkTa3g1: {
          nick: 'Derfette',
          operatorId: 'THNDR',
          position: 83,
          rank: 81,
          value: 7,
        },
        'ddb64a25-32bc-4d73-9984-9f23fad233b6': {
          nick: 'justthatdude22',
          operatorId: 'speed',
          position: 35,
          rank: 35,
          value: 25.5,
        },
        dhRg94DlEdRvFHiXuNTNNeHVDBV2: {
          nick: 'PainKiller',
          operatorId: 'THNDR',
          position: 95,
          rank: 91,
          value: 5.5,
        },
        'e1259244-ddab-4a4c-874e-2fc8eb4592a0': {
          nick: 'Jovie Ace Radoc',
          operatorId: 'speed',
          position: 58,
          rank: 58,
          value: 11.5,
        },
        'e8fc3e24-5a86-407e-890c-95ff3009b2ee': {
          nick: 'Omid ariya',
          operatorId: 'speed',
          position: 90,
          rank: 89,
          value: 6,
        },
        'e958b29d-7cae-4ef2-b360-f5e52f131caa': {
          nick: 'Akos Pinter',
          operatorId: 'speed',
          position: 88,
          rank: 87,
          value: 6.5,
        },
        eOAV5NVHQmVnL3Pl6fryQ7C3O0C3: {
          nick: 'jeaclaphi',
          operatorId: 'THNDR',
          position: 45,
          rank: 44,
          value: 19.5,
        },
        'ed515bf0-75ed-4319-a22c-7712aa182791': {
          nick: 'rgalexander216',
          operatorId: 'betopenly',
          position: 4,
          rank: 4,
          value: 312,
        },
        'f067b3f1-3620-4ea9-ac84-18de42911edf': {
          nick: 'neckfoot',
          operatorId: 'betopenly',
          position: 10,
          rank: 10,
          value: 126,
        },
        'f84f0522-8325-4b53-903d-b04230e14eda': {
          nick: 'Rexdentron',
          operatorId: 'telegram',
          position: 13,
          rank: 13,
          value: 95,
        },
        'fcc82108-0f0f-4983-83e9-eda9470abc46': {
          nick: 'James Stavros II',
          operatorId: 'speed',
          position: 68,
          rank: 66,
          value: 9,
        },
        gfo53QJFheeg3czzp2zI6OuLFWk2: {
          nick: '1000 is not enough',
          operatorId: 'THNDR',
          position: 3,
          rank: 3,
          value: 452.5,
        },
        jBKWmUfEzkNLX2UaCMd0i7dMkNF2: {
          nick: 'GBleezy',
          operatorId: 'THNDR',
          position: 71,
          rank: 69,
          value: 8.5,
        },
        meK5vW1SDdUv5ZK7idQyWHqXYKR2: {
          nick: 'wso18',
          operatorId: 'THNDR',
          position: 18,
          rank: 18,
          value: 70.5,
        },
        mnC7qAmth4PsCcsyfqlXCiADlhr1: {
          nick: 'Elu4454',
          operatorId: 'THNDR',
          position: 28,
          rank: 28,
          value: 38,
        },
        nToQ1lWacwVaiZ10wmzaXUYd1dS2: {
          nick: 'gastongg5',
          operatorId: 'THNDR',
          position: 61,
          rank: 60,
          value: 11,
        },
        oisvSc32PxW85NRMBCeBnFjAkAv2: {
          nick: 'gizmodeus',
          operatorId: 'THNDR',
          position: 64,
          rank: 60,
          value: 11,
        },
        pFHblNG3yyPrtOCq4Zwb4CYvFdB3: {
          nick: 'amaleshko',
          operatorId: 'THNDR',
          position: 76,
          rank: 76,
          value: 7.5,
        },
        pJEGDyOweoTEKlJ0NsALblBYgpb2: {
          nick: 'Diegote',
          operatorId: 'THNDR',
          position: 23,
          rank: 23,
          value: 46.5,
        },
        qENvX9vRToPBnFcTB5d69zq8Vog1: {
          nick: 'b3snakes',
          operatorId: 'THNDR',
          position: 17,
          rank: 17,
          value: 73,
        },
        qpgdvttycFQIv9fZJOIHGytNznO2: {
          nick: 'mwg',
          operatorId: 'THNDR',
          position: 82,
          rank: 81,
          value: 7,
        },
        s0Qlml5rUfftTdPvAOEfBeaGslT2: {
          nick: 'katie',
          operatorId: 'THNDR',
          position: 9,
          rank: 9,
          value: 128,
        },
        skgHapOl78YI5kbUTU4hnfZZeCt1: {
          nick: 'ustn26',
          operatorId: 'THNDR',
          position: 85,
          rank: 81,
          value: 7,
        },
        tR64VxeOkaPQpJTmzWFYWGWe35k2: {
          nick: 'Scammer',
          operatorId: 'THNDR',
          position: 39,
          rank: 39,
          value: 23.5,
        },
        vbeiYxytClOFdnTKBK28l05yP7F3: {
          nick: 'Katie',
          operatorId: 'THNDR',
          position: 54,
          rank: 54,
          value: 14,
        },
        vfrqXxPqY9WZPSbem0Clz8vyRTn1: {
          nick: 'passie',
          operatorId: 'THNDR',
          position: 43,
          rank: 43,
          value: 21.5,
        },
        wwACEIvG3LWbirz1Axs5XM0RDyh2: {
          nick: 'DemonaZA',
          operatorId: 'THNDR',
          position: 47,
          rank: 47,
          value: 18,
        },
        x9VO8NZNT9QRnpxpKImdBk1gtVi1: {
          nick: 'Twiztidcrypto',
          operatorId: 'THNDR',
          position: 72,
          rank: 72,
          value: 8,
        },
      },
    },
  },
};

export const LEADERBOARD_MOSTMONEY_30DAY = {
  status: 200,
  body: {
    status: 200,
    msg: 'Leaderboard',
    data: {
      lastUpdated: 1741615204776,
      leaderboardData: {
        '072QdZ88oXdxRDekQbeqr5PIBCN2': {
          nick: 'Rubocop32',
          operatorId: 'THNDR',
          position: 95,
          rank: 95,
          value: 40,
        },
        '0ANFbHbkKXgv2ss6NJ1oLB5jxli2': {
          nick: 'Woo',
          operatorId: 'THNDR',
          position: 20,
          rank: 20,
          value: 264.5,
        },
        '0PKCBsyGNdMBmavsyZ0y9y2wjGK2': {
          nick: 'SJJMR',
          operatorId: 'THNDR',
          position: 22,
          rank: 22,
          value: 257,
        },
        '0a601196-0273-4a00-98a7-cf620289459c': {
          nick: 'Artificial Intelligence',
          operatorId: 'speed',
          position: 77,
          rank: 77,
          value: 56.5,
        },
        '124be09a-fff4-4374-ae3e-8dc032702697': {
          nick: 'kostya nnn',
          operatorId: 'speed',
          position: 89,
          rank: 88,
          value: 45,
        },
        '1ca18461-1a7f-4889-b084-57365f879290': {
          nick: 'Jayjay Garcia',
          operatorId: 'speed',
          position: 90,
          rank: 90,
          value: 44,
        },
        '1d9f64b7-eeaa-4d25-9335-bb701bebfe70': {
          nick: 'conch',
          operatorId: 'betopenly',
          position: 4,
          rank: 4,
          value: 812,
        },
        '1dacdc28-62c9-46e5-97bb-a8695195f333': {
          nick: 'Pedro Oliveira',
          operatorId: 'speed',
          position: 85,
          rank: 85,
          value: 48,
        },
        '21902c78-d99e-45e7-b050-f1ac3e37807b': {
          nick: 'Flemmon Cochran',
          operatorId: 'speed',
          position: 43,
          rank: 43,
          value: 129,
        },
        '225f86af-d71b-467d-bff4-44b9fff35204': {
          nick: 'Logan Elberson',
          operatorId: 'speed',
          position: 97,
          rank: 97,
          value: 38,
        },
        '2f695159-4099-4b89-b38e-1468dd7cfc95': {
          nick: 'jbrug420',
          operatorId: 'betopenly',
          position: 24,
          rank: 24,
          value: 242,
        },
        '2f9ccb6c-fea1-46c4-bcb3-0214c4abaf04': {
          nick: 'chessfan777',
          operatorId: 'betopenly',
          position: 44,
          rank: 44,
          value: 128,
        },
        '3250050e-ad3a-4d06-b779-bcc1b532dfe0': {
          nick: 'PazZayy',
          operatorId: 'telegram',
          position: 2,
          rank: 2,
          value: 2610,
        },
        '363e66f5-f6dc-439a-a7df-8e0dedffdab8': {
          nick: 'Matthieu Marquette',
          operatorId: 'speed',
          position: 96,
          rank: 96,
          value: 39,
        },
        '3cd545b4-5cef-4030-b598-ac9650f3032a': {
          nick: 'Gavin Livesey',
          operatorId: 'speed',
          position: 92,
          rank: 92,
          value: 42.5,
        },
        '46938e4c-bc24-45cd-9b93-460eef349086': {
          nick: 'Neshdan',
          operatorId: 'telegram',
          position: 28,
          rank: 28,
          value: 205.5,
        },
        '49eee239-a165-40c7-abcf-9a3e0a186258': {
          nick: 'mattwalker233',
          operatorId: 'betopenly',
          position: 75,
          rank: 75,
          value: 58,
        },
        '4I7HWcHGprVlEzbKOdrxCKAp49x1': {
          nick: 'Kendrab23',
          operatorId: 'THNDR',
          position: 59,
          rank: 59,
          value: 95.5,
        },
        '4W29W8plWNgZb3jFon56OFgNSHJ3': {
          nick: 'suckmydiesel',
          operatorId: 'THNDR',
          position: 55,
          rank: 55,
          value: 114,
        },
        '4aa0ed64-17d4-42ac-80dc-9276c6b261e5': {
          nick: 'James Ferrell',
          operatorId: 'speed',
          position: 87,
          rank: 87,
          value: 46,
        },
        '4fd076ff-c2fd-4918-bc17-b01a9f89781b': {
          nick: 'Malibongwe Darkness',
          operatorId: 'speed',
          position: 61,
          rank: 61,
          value: 88,
        },
        '58f0cdf9-62a5-4516-b147-562ebd9e6925': {
          nick: 'wolfpack_trivia',
          operatorId: 'telegram',
          position: 80,
          rank: 80,
          value: 54,
        },
        '5Mzv0biDtURWH4EydiX8gIHpxWC3': {
          nick: 'RcEverSauce',
          operatorId: 'THNDR',
          position: 30,
          rank: 30,
          value: 178.5,
        },
        '5QfuKqzJ77cjIzIMpbirJPKig8w2': {
          nick: 'BtceXMasteR',
          operatorId: 'THNDR',
          position: 47,
          rank: 47,
          value: 126.5,
        },
        '5fc5b679-0c9e-42da-ab0e-70a94e17e3e3': {
          nick: 'Luis Espinoza',
          operatorId: 'speed',
          position: 86,
          rank: 86,
          value: 46.5,
        },
        '5jNmL86kHiNoVmH8V2a0CSj44Ys2': {
          nick: 'luzpurazo02',
          operatorId: 'THNDR',
          position: 11,
          rank: 11,
          value: 376.5,
        },
        '661edc86-6229-44dd-87b3-0d072132cd98': {
          nick: 'Kevin Cesar',
          operatorId: 'speed',
          position: 73,
          rank: 73,
          value: 65,
        },
        '71fcc902-113d-4a36-8f6d-3b7e9f84d50c': {
          nick: 'OmarCripto86',
          operatorId: 'telegram',
          position: 15,
          rank: 15,
          value: 339,
        },
        '754a6395-04f9-4d0d-a9fc-4cef356edae3': {
          nick: 'lukep2002',
          operatorId: 'betopenly',
          position: 93,
          rank: 93,
          value: 42,
        },
        '79d3cb1b-218b-4258-b38f-bb856d8c859b': {
          nick: 'lilmissthing',
          operatorId: 'betopenly',
          position: 66,
          rank: 66,
          value: 78,
        },
        '7SxpldVWl9Yd0cmtMqOopOzaplD2': {
          nick: 'Jefe',
          operatorId: 'THNDR',
          position: 10,
          rank: 10,
          value: 419,
        },
        '7c9c87b4-b522-4689-8af2-9b889bb31bc3': {
          nick: 'mattford',
          operatorId: 'betopenly',
          position: 13,
          rank: 13,
          value: 368,
        },
        '7hJKmzdLguYHE8XsshEA1t6xLCM2': {
          nick: 'Maco0404',
          operatorId: 'THNDR',
          position: 21,
          rank: 21,
          value: 261,
        },
        '7iy1eIPdxxZkmVFi9IcNsIXUc3x1': {
          nick: 'ww815',
          operatorId: 'THNDR',
          position: 6,
          rank: 6,
          value: 732,
        },
        '7kFibKihfwcOikCCBsFDduclW2C3': {
          nick: 'jeondongcheol',
          operatorId: 'THNDR',
          position: 100,
          rank: 100,
          value: 36.5,
        },
        '82a0396c-0368-4c2f-aa93-a2fb5abbd873': {
          nick: 'K Sathosi',
          operatorId: 'speed',
          position: 46,
          rank: 44,
          value: 128,
        },
        '86c32412-7374-49d1-a9d7-0ecfb4630127': {
          nick: 'Dheyaisgavidia',
          operatorId: 'telegram',
          position: 50,
          rank: 50,
          value: 122,
        },
        '8NkSyaqCHFbnrHdqu2hTdbAvIdp1': {
          nick: 'mamba mentality',
          operatorId: 'THNDR',
          position: 91,
          rank: 91,
          value: 43.5,
        },
        '8OZsOXfGwkVaABjaAxKdsFYvPnt1': {
          nick: 'adedede',
          operatorId: 'THNDR',
          position: 82,
          rank: 82,
          value: 51,
        },
        '8UMAWbAqTOPcuPJiv3z8vNDjdfN2': {
          nick: 'BOTNIQ',
          operatorId: 'THNDR',
          position: 76,
          rank: 76,
          value: 57,
        },
        '9d9d67d7-88c0-4c96-b5d3-03d0d7cea8a8': {
          nick: 'Farshad Hajinejad',
          operatorId: 'speed',
          position: 88,
          rank: 88,
          value: 45,
        },
        B7W0BEKPOFfKcyuxHBO4S2tNqIU2: {
          nick: 'RuegoOhYXZqqh7',
          operatorId: 'THNDR',
          position: 54,
          rank: 54,
          value: 115,
        },
        DquvTqsjUWhHmfwDxweisAaVbSs1: {
          nick: 'Jason B',
          operatorId: 'THNDR',
          position: 17,
          rank: 17,
          value: 306,
        },
        DuTSHjO8XrZBLxkoPt6v6x6Xp9n1: {
          nick: '1ll',
          operatorId: 'THNDR',
          position: 83,
          rank: 83,
          value: 50,
        },
        E3PPyFdgU2cCYUQ02Gk35OHSHbo2: {
          nick: 'richmondtina',
          operatorId: 'THNDR',
          position: 32,
          rank: 32,
          value: 166,
        },
        EH28THF8y1gU8fM89ykJJkmYP9T2: {
          nick: 'Rexdentron',
          operatorId: 'THNDR',
          position: 1,
          rank: 1,
          value: 4884,
        },
        EVyM1oeCRCVVbO9OqPAedE52Mck2: {
          nick: 'puerto',
          operatorId: 'THNDR',
          position: 34,
          rank: 34,
          value: 157.5,
        },
        Eb1dnspHYUSrNEB2ZzLXrE0cDGk2: {
          nick: 'Dik',
          operatorId: 'THNDR',
          position: 94,
          rank: 94,
          value: 41.5,
        },
        Fzx6iXUiHDWJ71nrI90ZdY1wZNr2: {
          nick: 'orangepillee',
          operatorId: 'THNDR',
          position: 68,
          rank: 68,
          value: 72,
        },
        J9krVBUj4zdkwNDqPWv913KMsFY2: {
          nick: 'jahdidit',
          operatorId: 'THNDR',
          position: 45,
          rank: 44,
          value: 128,
        },
        JqiNCGXjkaMqEYFPOYCaW0qcYfl1: {
          nick: 'privateprinzesska',
          operatorId: 'THNDR',
          position: 8,
          rank: 8,
          value: 497,
        },
        KCby6YRbgJZ6xV7XFWd6ltx3Ppf2: {
          nick: 'bagkoyy',
          operatorId: 'THNDR',
          position: 67,
          rank: 67,
          value: 75.5,
        },
        LhoQSyiO1ZPeJrQSgHMXxDhOshw1: {
          nick: 'Louie22',
          operatorId: 'THNDR',
          position: 29,
          rank: 29,
          value: 192.5,
        },
        NHezp26RNOdWX1KZMgpCyzw57Mn1: {
          nick: 'ProfessorSyma',
          operatorId: 'THNDR',
          position: 81,
          rank: 81,
          value: 51.5,
        },
        OBvLyuG4l3ecP4zQaah1naAnNpy1: {
          nick: 'WhiteGangsta',
          operatorId: 'THNDR',
          position: 60,
          rank: 60,
          value: 89,
        },
        RBqDRktOYRaONpnrdbA3kgoZG1w2: {
          nick: 'bigchungus',
          operatorId: 'THNDR',
          position: 70,
          rank: 70,
          value: 68,
        },
        SZNpkP4YeYM6emUlJJcPuvlKJE72: {
          nick: 'Rhea',
          operatorId: 'THNDR',
          position: 42,
          rank: 42,
          value: 130,
        },
        VQ21Q4670YhnSk3GrAM6pbLQ6kq2: {
          nick: 'MonkeyMan',
          operatorId: 'THNDR',
          position: 5,
          rank: 5,
          value: 749,
        },
        ZMTLpjA302MAfCMB2ZUdHuvAlBp2: {
          nick: 'spideman',
          operatorId: 'THNDR',
          position: 16,
          rank: 16,
          value: 308.5,
        },
        ZP1PfEawyDcVCtIwqCFuGuFmP1U2: {
          nick: 'la mera verga',
          operatorId: 'THNDR',
          position: 51,
          rank: 51,
          value: 118,
        },
        Zaqo7osp1fgDHKV1xqq7vRAzl6k2: {
          nick: 'maxpow',
          operatorId: 'THNDR',
          position: 56,
          rank: 56,
          value: 103.5,
        },
        ZkoCf7kXVDfowrts5pSLfjNCVFr2: {
          nick: 'godneverdie',
          operatorId: 'THNDR',
          position: 14,
          rank: 14,
          value: 339.5,
        },
        'a1ed0c26-aaf5-4449-9910-625bf85a81ea': {
          nick: 'zebo',
          operatorId: 'betopenly',
          position: 27,
          rank: 27,
          value: 208,
        },
        aEQF5MSwwAPC0v1MTbbjs1vqskK2: {
          nick: 'tilin',
          operatorId: 'THNDR',
          position: 52,
          rank: 52,
          value: 117,
        },
        aQ4boibSzZgJhL1hr0YQ8dTaFEX2: {
          nick: 'spacekais',
          operatorId: 'THNDR',
          position: 78,
          rank: 78,
          value: 55.5,
        },
        'aefd3fb3-65ed-4832-a630-acb913053ffb': {
          nick: 'Lucas Hubbard',
          operatorId: 'speed',
          position: 25,
          rank: 25,
          value: 222,
        },
        b02uR9KB8tYrSNLLLFDV7MV2vWL2: {
          nick: 'afshin',
          operatorId: 'THNDR',
          position: 40,
          rank: 40,
          value: 135.5,
        },
        'b0ebb43a-9835-4e67-ba2c-4e0930ef911f': {
          nick: 'Austin Villella',
          operatorId: 'speed',
          position: 72,
          rank: 72,
          value: 66,
        },
        'bba0b072-830d-4976-870b-6db6da04b19e': {
          nick: 'Shawn Dunlap',
          operatorId: 'speed',
          position: 65,
          rank: 65,
          value: 81.5,
        },
        'c07a5ee3-26a7-44eb-b0b2-f088df935edb': {
          nick: 'Dat Nguyen',
          operatorId: 'speed',
          position: 64,
          rank: 64,
          value: 83.5,
        },
        'c8e102a7-3b11-4749-a03f-f722828e27f5': {
          nick: 'Daniarmando',
          operatorId: 'telegram',
          position: 69,
          rank: 69,
          value: 71,
        },
        cLVJXQObd7Q7CTYRJT0asGIG4ub2: {
          nick: 'leokim',
          operatorId: 'THNDR',
          position: 19,
          rank: 19,
          value: 283.5,
        },
        'ceca90a3-6ac2-476b-b5f5-8aadf250a220': {
          nick: 'ferrari16',
          operatorId: 'betopenly',
          position: 35,
          rank: 35,
          value: 156,
        },
        ceeWs4u2PaMHUifqGrcjwtEPVpe2: {
          nick: 'Maco04',
          operatorId: 'THNDR',
          position: 23,
          rank: 23,
          value: 249,
        },
        cpe6vtDd1TYuxM7wwapCGPd5zMr2: {
          nick: 'Radentor',
          operatorId: 'THNDR',
          position: 39,
          rank: 39,
          value: 138.5,
        },
        'd54eb816-dcbc-4d12-8083-408681a4a8b7': {
          nick: 'Kelly Moon',
          operatorId: 'speed',
          position: 49,
          rank: 49,
          value: 125,
        },
        'ddb64a25-32bc-4d73-9984-9f23fad233b6': {
          nick: 'justthatdude22',
          operatorId: 'speed',
          position: 71,
          rank: 71,
          value: 67,
        },
        'dfd85ba2-de70-41ad-91b5-e76c8b8a4b31': {
          nick: 'youwinuyen',
          operatorId: 'betopenly',
          position: 37,
          rank: 37,
          value: 142,
        },
        'e466aec5-c2d8-4d4a-aa1d-b69b985c3f6a': {
          nick: 'justint24',
          operatorId: 'betopenly',
          position: 9,
          rank: 9,
          value: 432,
        },
        'e48c5007-8874-4cdd-93aa-b19b05f587a7': {
          nick: 'structo',
          operatorId: 'betopenly',
          position: 58,
          rank: 58,
          value: 98,
        },
        'ed515bf0-75ed-4319-a22c-7712aa182791': {
          nick: 'rgalexander216',
          operatorId: 'betopenly',
          position: 7,
          rank: 7,
          value: 642,
        },
        'f067b3f1-3620-4ea9-ac84-18de42911edf': {
          nick: 'neckfoot',
          operatorId: 'betopenly',
          position: 48,
          rank: 48,
          value: 126,
        },
        'f7f1964a-137c-45ba-a5cf-d782ecd57548': {
          nick: 'player93632',
          operatorId: 'telegram',
          position: 74,
          rank: 74,
          value: 64.5,
        },
        'f84f0522-8325-4b53-903d-b04230e14eda': {
          nick: 'Rexdentron',
          operatorId: 'telegram',
          position: 41,
          rank: 41,
          value: 131,
        },
        'faf8c5db-ed3e-43b5-8ef1-e094d67f585b': {
          nick: 'Jason Broderick',
          operatorId: 'speed',
          position: 38,
          rank: 38,
          value: 140,
        },
        'fd88225d-c296-472e-8ab5-bcec8dcaf8ae': {
          nick: 'Haley Robison',
          operatorId: 'speed',
          position: 98,
          rank: 98,
          value: 37.5,
        },
        gf1spz6Jmsg3wMycVm7RyMKERNs1: {
          nick: 'littleminer',
          operatorId: 'THNDR',
          position: 33,
          rank: 33,
          value: 158,
        },
        gfo53QJFheeg3czzp2zI6OuLFWk2: {
          nick: '1000 is not enough',
          operatorId: 'THNDR',
          position: 3,
          rank: 3,
          value: 1138,
        },
        lTFxkD8kb4cU31Xucj8e7FIYfAk2: {
          nick: 'lulo',
          operatorId: 'THNDR',
          position: 63,
          rank: 62,
          value: 85,
        },
        meK5vW1SDdUv5ZK7idQyWHqXYKR2: {
          nick: 'wso18',
          operatorId: 'THNDR',
          position: 18,
          rank: 18,
          value: 300,
        },
        mnC7qAmth4PsCcsyfqlXCiADlhr1: {
          nick: 'Elu4454',
          operatorId: 'THNDR',
          position: 84,
          rank: 84,
          value: 49,
        },
        nuAygUHipvZoxHisDuv4GCk2mHe2: {
          nick: 'diyann',
          operatorId: 'THNDR',
          position: 57,
          rank: 57,
          value: 101,
        },
        pJEGDyOweoTEKlJ0NsALblBYgpb2: {
          nick: 'Diegote',
          operatorId: 'THNDR',
          position: 31,
          rank: 31,
          value: 175.5,
        },
        qENvX9vRToPBnFcTB5d69zq8Vog1: {
          nick: 'b3snakes',
          operatorId: 'THNDR',
          position: 26,
          rank: 26,
          value: 210,
        },
        qRmDm0SvbuYwfg7o9OCGNP8oCkJ2: {
          nick: 'Lixeeer',
          operatorId: 'THNDR',
          position: 36,
          rank: 36,
          value: 144.5,
        },
        rUKCFNYcroWblcf61IMxAkH1kXh1: {
          nick: 'El Belico',
          operatorId: 'THNDR',
          position: 62,
          rank: 62,
          value: 85,
        },
        s0Qlml5rUfftTdPvAOEfBeaGslT2: {
          nick: 'katie',
          operatorId: 'THNDR',
          position: 12,
          rank: 12,
          value: 373.5,
        },
        vfrqXxPqY9WZPSbem0Clz8vyRTn1: {
          nick: 'passie',
          operatorId: 'THNDR',
          position: 53,
          rank: 53,
          value: 116,
        },
        wIAi000qCseXDvrKi8DrUZJsOnF3: {
          nick: 'mamitos',
          operatorId: 'THNDR',
          position: 99,
          rank: 98,
          value: 37.5,
        },
        wwACEIvG3LWbirz1Axs5XM0RDyh2: {
          nick: 'DemonaZA',
          operatorId: 'THNDR',
          position: 79,
          rank: 79,
          value: 55,
        },
      },
    },
  },
};

export const LEADERBOARD_MOSTMONEY_ALLTIME = {
  status: 200,
  body: {
    status: 200,
    msg: 'Leaderboard',
    data: {
      lastUpdated: 1741615204776,
      leaderboardData: {
        '0ANFbHbkKXgv2ss6NJ1oLB5jxli2': {
          nick: 'Woo',
          operatorId: 'THNDR',
          position: 88,
          rank: 88,
          value: 289.5,
        },
        '0PKCBsyGNdMBmavsyZ0y9y2wjGK2': {
          nick: 'SJJMR',
          operatorId: 'THNDR',
          position: 33,
          rank: 33,
          value: 1096.5,
        },
        '1d9f64b7-eeaa-4d25-9335-bb701bebfe70': {
          nick: 'conch',
          operatorId: 'betopenly',
          position: 2,
          rank: 2,
          value: 17642,
        },
        '1f73e8e2-6a83-48ac-9698-1efe066c7311': {
          nick: 'ypalermo',
          operatorId: 'betopenly',
          position: 3,
          rank: 3,
          value: 17404,
        },
        '221426fa-99a2-44ca-ad3a-bc46731f854d': {
          nick: 'ltlmoney',
          operatorId: 'betopenly',
          position: 79,
          rank: 79,
          value: 310,
        },
        '22dbe726-a700-4dc2-8e81-9456f822ff4a': {
          nick: 'paulelias',
          operatorId: 'betopenly',
          position: 14,
          rank: 14,
          value: 3604,
        },
        '2bigJaMNqcUKEZdjTpiIRQSyvjE3': {
          nick: 'rafaelpac',
          operatorId: 'THNDR',
          position: 51,
          rank: 51,
          value: 617.4800000000001,
        },
        '2f695159-4099-4b89-b38e-1468dd7cfc95': {
          nick: 'jbrug420',
          operatorId: 'betopenly',
          position: 98,
          rank: 98,
          value: 242,
        },
        '3250050e-ad3a-4d06-b779-bcc1b532dfe0': {
          nick: 'PazZayy',
          operatorId: 'telegram',
          position: 6,
          rank: 6,
          value: 7769,
        },
        '3QAxWGj1sXRgi1ZTKfUjQQ3GLuU2': {
          nick: 'Bignug',
          operatorId: 'THNDR',
          position: 99,
          rank: 99,
          value: 240.5,
        },
        '46938e4c-bc24-45cd-9b93-460eef349086': {
          nick: 'Neshdan',
          operatorId: 'telegram',
          position: 74,
          rank: 74,
          value: 351,
        },
        '4DVMucyDaTWO8ERtpEoatTqEBr52': {
          nick: 'D0G3',
          operatorId: 'THNDR',
          position: 59,
          rank: 59,
          value: 515.5,
        },
        '4W29W8plWNgZb3jFon56OFgNSHJ3': {
          nick: 'suckmydiesel',
          operatorId: 'THNDR',
          position: 39,
          rank: 39,
          value: 823.5,
        },
        '5Mzv0biDtURWH4EydiX8gIHpxWC3': {
          nick: 'RcEverSauce',
          operatorId: 'THNDR',
          position: 67,
          rank: 67,
          value: 439,
        },
        '5jNmL86kHiNoVmH8V2a0CSj44Ys2': {
          nick: 'luzpurazo02',
          operatorId: 'THNDR',
          position: 15,
          rank: 15,
          value: 3579.5,
        },
        '6924b090-175c-40dc-a978-0fdf3bd7f850': {
          nick: 'mikek2057',
          operatorId: 'betopenly',
          position: 52,
          rank: 52,
          value: 608,
        },
        '71fcc902-113d-4a36-8f6d-3b7e9f84d50c': {
          nick: 'OmarCripto86',
          operatorId: 'telegram',
          position: 28,
          rank: 28,
          value: 1294.5,
        },
        '7SxpldVWl9Yd0cmtMqOopOzaplD2': {
          nick: 'Jefe',
          operatorId: 'THNDR',
          position: 63,
          rank: 63,
          value: 458,
        },
        '7c9c87b4-b522-4689-8af2-9b889bb31bc3': {
          nick: 'mattford',
          operatorId: 'betopenly',
          position: 22,
          rank: 22,
          value: 1852,
        },
        '7hJKmzdLguYHE8XsshEA1t6xLCM2': {
          nick: 'Maco0404',
          operatorId: 'THNDR',
          position: 45,
          rank: 45,
          value: 738,
        },
        '7iy1eIPdxxZkmVFi9IcNsIXUc3x1': {
          nick: 'ww815',
          operatorId: 'THNDR',
          position: 29,
          rank: 29,
          value: 1282,
        },
        '7tfVggLBeTgKDQ0nLdAxwxEGrWn1': {
          nick: 'Shutupandtakemymoney',
          operatorId: 'THNDR',
          position: 23,
          rank: 23,
          value: 1575.8000000000002,
        },
        '8NkSyaqCHFbnrHdqu2hTdbAvIdp1': {
          nick: 'mamba mentality',
          operatorId: 'THNDR',
          position: 89,
          rank: 89,
          value: 288.78000000000003,
        },
        '8UMAWbAqTOPcuPJiv3z8vNDjdfN2': {
          nick: 'BOTNIQ',
          operatorId: 'THNDR',
          position: 95,
          rank: 95,
          value: 248.5,
        },
        '8xODgRyjLONd88fqcPoeyawK2QI3': {
          nick: 'imk2022',
          operatorId: 'THNDR',
          position: 84,
          rank: 84,
          value: 302.5,
        },
        '985e1e39-dd4e-40eb-a673-4da93d8d2365': {
          nick: 'pulkitrampa',
          operatorId: 'betopenly',
          position: 20,
          rank: 20,
          value: 1920,
        },
        B7W0BEKPOFfKcyuxHBO4S2tNqIU2: {
          nick: 'RuegoOhYXZqqh7',
          operatorId: 'THNDR',
          position: 55,
          rank: 55,
          value: 561.5,
        },
        BG91lF38izThS1eBJ0kklLeCmeI3: {
          nick: 'Cryptonator',
          operatorId: 'THNDR',
          position: 60,
          rank: 60,
          value: 505.7000000000001,
        },
        BIMH6yaAn7NapBRCl03x7na5Ji73: {
          nick: 'random39',
          operatorId: 'THNDR',
          position: 78,
          rank: 78,
          value: 316.5,
        },
        DquvTqsjUWhHmfwDxweisAaVbSs1: {
          nick: 'Jason B',
          operatorId: 'THNDR',
          position: 76,
          rank: 76,
          value: 338,
        },
        E3PPyFdgU2cCYUQ02Gk35OHSHbo2: {
          nick: 'richmondtina',
          operatorId: 'THNDR',
          position: 35,
          rank: 35,
          value: 1023.5,
        },
        EH28THF8y1gU8fM89ykJJkmYP9T2: {
          nick: 'Rexdentron',
          operatorId: 'THNDR',
          position: 1,
          rank: 1,
          value: 35283,
        },
        Fj0SHclZIDapRYmq9FXThI9z6B73: {
          nick: 'Tecky42',
          operatorId: 'THNDR',
          position: 77,
          rank: 77,
          value: 333.5,
        },
        GCuLSzNyeIMdtFwffzpCoCDRVPv1: {
          nick: 'harro',
          operatorId: 'THNDR',
          position: 40,
          rank: 40,
          value: 797.5,
        },
        HN4cjQOv0vSDMhmVEo2glGZFx9q1: {
          nick: 'nido76',
          operatorId: 'THNDR',
          position: 71,
          rank: 71,
          value: 407,
        },
        IcvXSN5IGhMuc8Bjr15wTMUyRbj2: {
          nick: 'Bellesbeastzbdgg',
          operatorId: 'THNDR',
          position: 86,
          rank: 86,
          value: 298.5,
        },
        JqiNCGXjkaMqEYFPOYCaW0qcYfl1: {
          nick: 'privateprinzesska',
          operatorId: 'THNDR',
          position: 8,
          rank: 8,
          value: 5520.5,
        },
        LhoQSyiO1ZPeJrQSgHMXxDhOshw1: {
          nick: 'Louie22',
          operatorId: 'THNDR',
          position: 57,
          rank: 57,
          value: 517,
        },
        LjAvwnY7DSb7FdzT7Xonp0ewjuy1: {
          nick: 'h1gher',
          operatorId: 'THNDR',
          position: 16,
          rank: 16,
          value: 3030.5,
        },
        NHezp26RNOdWX1KZMgpCyzw57Mn1: {
          nick: 'ProfessorSyma',
          operatorId: 'THNDR',
          position: 19,
          rank: 19,
          value: 2227.1800000000003,
        },
        OBvLyuG4l3ecP4zQaah1naAnNpy1: {
          nick: 'WhiteGangsta',
          operatorId: 'THNDR',
          position: 62,
          rank: 62,
          value: 485.5,
        },
        SZNpkP4YeYM6emUlJJcPuvlKJE72: {
          nick: 'Rhea',
          operatorId: 'THNDR',
          position: 47,
          rank: 47,
          value: 687,
        },
        Tl9dDwvCSjOjsKZQqB7eXv0Laho2: {
          nick: 'brotoshi',
          operatorId: 'THNDR',
          position: 53,
          rank: 53,
          value: 571,
        },
        TwgWSWsqIrdx27z1Hvlb0EEaB3u1: {
          nick: 'raim1',
          operatorId: 'THNDR',
          position: 50,
          rank: 50,
          value: 634,
        },
        VQ21Q4670YhnSk3GrAM6pbLQ6kq2: {
          nick: 'MonkeyMan',
          operatorId: 'THNDR',
          position: 11,
          rank: 11,
          value: 4422,
        },
        YjPZOYpdJOYEhjQgeNmfORFUjqE3: {
          nick: 'kylieky',
          operatorId: 'THNDR',
          position: 96,
          rank: 96,
          value: 248.3,
        },
        ZMTLpjA302MAfCMB2ZUdHuvAlBp2: {
          nick: 'spideman',
          operatorId: 'THNDR',
          position: 81,
          rank: 81,
          value: 308.5,
        },
        ZP1PfEawyDcVCtIwqCFuGuFmP1U2: {
          nick: 'la mera verga',
          operatorId: 'THNDR',
          position: 93,
          rank: 93,
          value: 255.5,
        },
        ZkoCf7kXVDfowrts5pSLfjNCVFr2: {
          nick: 'godneverdie',
          operatorId: 'THNDR',
          position: 75,
          rank: 75,
          value: 339.5,
        },
        'a1ed0c26-aaf5-4449-9910-625bf85a81ea': {
          nick: 'zebo',
          operatorId: 'betopenly',
          position: 85,
          rank: 85,
          value: 300,
        },
        aEQF5MSwwAPC0v1MTbbjs1vqskK2: {
          nick: 'tilin',
          operatorId: 'THNDR',
          position: 10,
          rank: 10,
          value: 4541,
        },
        'aefd3fb3-65ed-4832-a630-acb913053ffb': {
          nick: 'Lucas Hubbard',
          operatorId: 'speed',
          position: 69,
          rank: 69,
          value: 420,
        },
        bOJKFpQsSiUOaFJsDMIGp1Yjv6Z2: {
          nick: 'Jimmywpu1',
          operatorId: 'THNDR',
          position: 46,
          rank: 46,
          value: 700,
        },
        'bc395208-8a6e-4ebd-a519-6c9d57855c9c': {
          nick: 'rhrn1998',
          operatorId: 'telegram',
          position: 92,
          rank: 92,
          value: 259.5,
        },
        'c07a5ee3-26a7-44eb-b0b2-f088df935edb': {
          nick: 'Dat Nguyen',
          operatorId: 'speed',
          position: 54,
          rank: 54,
          value: 569.5,
        },
        'c9b6a78a-0276-4104-bf29-243a35249017': {
          nick: 'j20dunn',
          operatorId: 'betopenly',
          position: 44,
          rank: 44,
          value: 768,
        },
        cLVJXQObd7Q7CTYRJT0asGIG4ub2: {
          nick: 'leokim',
          operatorId: 'THNDR',
          position: 43,
          rank: 43,
          value: 769.5,
        },
        'cc6f4442-6e59-4b4a-a5d6-5b3c3b331d94': {
          nick: 'thomasm06',
          operatorId: 'betopenly',
          position: 48,
          rank: 48,
          value: 664,
        },
        'cda2a6d9-0770-4a3a-9155-3d9f41b3dd95': {
          nick: 'nickps',
          operatorId: 'betopenly',
          position: 5,
          rank: 5,
          value: 8280,
        },
        ceeWs4u2PaMHUifqGrcjwtEPVpe2: {
          nick: 'Maco04',
          operatorId: 'THNDR',
          position: 36,
          rank: 36,
          value: 971,
        },
        cpe6vtDd1TYuxM7wwapCGPd5zMr2: {
          nick: 'Radentor',
          operatorId: 'THNDR',
          position: 9,
          rank: 9,
          value: 4804.400000000001,
        },
        'd54eb816-dcbc-4d12-8083-408681a4a8b7': {
          nick: 'Kelly Moon',
          operatorId: 'speed',
          position: 37,
          rank: 37,
          value: 938.5,
        },
        'da352494-7278-49db-903a-d338e0eaa5c0': {
          nick: 'squirrly',
          operatorId: 'betopenly',
          position: 27,
          rank: 27,
          value: 1308,
        },
        'dfd85ba2-de70-41ad-91b5-e76c8b8a4b31': {
          nick: 'youwinuyen',
          operatorId: 'betopenly',
          position: 58,
          rank: 58,
          value: 516,
        },
        'e466aec5-c2d8-4d4a-aa1d-b69b985c3f6a': {
          nick: 'justint24',
          operatorId: 'betopenly',
          position: 12,
          rank: 12,
          value: 4360,
        },
        'e5bf14b2-6c34-4fe1-99bf-831b98c3860e': {
          nick: 'dasauce8063',
          operatorId: 'betopenly',
          position: 64,
          rank: 64,
          value: 450,
        },
        'ea5cf715-7efd-4b60-afc5-8e449ae842aa': {
          nick: 'kisjugbe',
          operatorId: 'betopenly',
          position: 13,
          rank: 13,
          value: 3652,
        },
        'eaf6c455-0472-4a0a-9770-0b11878864e2': {
          nick: 'trodabaugh',
          operatorId: 'betopenly',
          position: 7,
          rank: 7,
          value: 5874,
        },
        'ed515bf0-75ed-4319-a22c-7712aa182791': {
          nick: 'rgalexander216',
          operatorId: 'betopenly',
          position: 49,
          rank: 49,
          value: 642,
        },
        'f3bacf77-fae7-4598-b3b2-a47f6a692f82': {
          nick: 'Luzpurazo',
          operatorId: 'telegram',
          position: 56,
          rank: 56,
          value: 536.5,
        },
        'f84f0522-8325-4b53-903d-b04230e14eda': {
          nick: 'Rexdentron',
          operatorId: 'telegram',
          position: 4,
          rank: 4,
          value: 9266.5,
        },
        fFUyVXARbnQduTEIEqAlbwn08eP2: {
          nick: 'PazZay',
          operatorId: 'THNDR',
          position: 38,
          rank: 38,
          value: 827,
        },
        'fcea4bc7-582a-4993-9b72-7b2d0a37c9ed': {
          nick: 'midamikx',
          operatorId: 'telegram',
          position: 83,
          rank: 83,
          value: 307.5,
        },
        gf1spz6Jmsg3wMycVm7RyMKERNs1: {
          nick: 'littleminer',
          operatorId: 'THNDR',
          position: 87,
          rank: 87,
          value: 292.5,
        },
        gfo53QJFheeg3czzp2zI6OuLFWk2: {
          nick: '1000 is not enough',
          operatorId: 'THNDR',
          position: 25,
          rank: 25,
          value: 1362.5,
        },
        hxld3PnZksN6N7HFXHXZV2g45Sg2: {
          nick: 'eldiablobo',
          operatorId: 'THNDR',
          position: 65,
          rank: 65,
          value: 448.5,
        },
        iMRdj6gJwwbvW5TFgGrPyfE2K9V2: {
          nick: 'yeah eyae hayeah',
          operatorId: 'THNDR',
          position: 66,
          rank: 66,
          value: 445.5,
        },
        iSktZeq7olZipQvAsBwPQ0kVQCk1: {
          nick: 'kball',
          operatorId: 'THNDR',
          position: 21,
          rank: 21,
          value: 1880.5,
        },
        m71e9TEHcQVI6gNtKnOA9V8uKCc2: {
          nick: 'Nat',
          operatorId: 'THNDR',
          position: 68,
          rank: 68,
          value: 438.62,
        },
        mRPtWnlvv2ZZX1LOKMw9EeV8PX03: {
          nick: 'Cola90',
          operatorId: 'THNDR',
          position: 82,
          rank: 82,
          value: 308,
        },
        meK5vW1SDdUv5ZK7idQyWHqXYKR2: {
          nick: 'wso18',
          operatorId: 'THNDR',
          position: 24,
          rank: 24,
          value: 1363,
        },
        nToQ1lWacwVaiZ10wmzaXUYd1dS2: {
          nick: 'gastongg5',
          operatorId: 'THNDR',
          position: 70,
          rank: 70,
          value: 414.14000000000004,
        },
        oEXGvwgloVSRJ7aqM48jRry0gp52: {
          nick: 'Lucky4aWhile',
          operatorId: 'THNDR',
          position: 31,
          rank: 31,
          value: 1148.5,
        },
        p8GyX01GGRZVQX2a0ih3OVegt1j2: {
          nick: 'kokojamboo',
          operatorId: 'THNDR',
          position: 30,
          rank: 30,
          value: 1165.5,
        },
        pJEGDyOweoTEKlJ0NsALblBYgpb2: {
          nick: 'Diegote',
          operatorId: 'THNDR',
          position: 80,
          rank: 80,
          value: 309.5,
        },
        pNzsBfAMula1p9k6CutPq8EU7u92: {
          nick: 'whyiodda',
          operatorId: 'THNDR',
          position: 94,
          rank: 93,
          value: 255.5,
        },
        qENvX9vRToPBnFcTB5d69zq8Vog1: {
          nick: 'b3snakes',
          operatorId: 'THNDR',
          position: 61,
          rank: 61,
          value: 488,
        },
        qRmDm0SvbuYwfg7o9OCGNP8oCkJ2: {
          nick: 'Lixeeer',
          operatorId: 'THNDR',
          position: 18,
          rank: 18,
          value: 2668.5,
        },
        qpgdvttycFQIv9fZJOIHGytNznO2: {
          nick: 'mwg',
          operatorId: 'THNDR',
          position: 17,
          rank: 17,
          value: 2775,
        },
        rUKCFNYcroWblcf61IMxAkH1kXh1: {
          nick: 'El Belico',
          operatorId: 'THNDR',
          position: 32,
          rank: 32,
          value: 1132.5,
        },
        s0Qlml5rUfftTdPvAOEfBeaGslT2: {
          nick: 'katie',
          operatorId: 'THNDR',
          position: 73,
          rank: 73,
          value: 373.5,
        },
        s8CuwoXVfKajUoHKYthX7Apvcz92: {
          nick: 'ralf',
          operatorId: 'THNDR',
          position: 42,
          rank: 42,
          value: 771,
        },
        sU0QcGkr0Pe60tUwItFdb1STzgn1: {
          nick: 'jennadeea',
          operatorId: 'THNDR',
          position: 72,
          rank: 72,
          value: 405.5,
        },
        tjXxUidlZwbToR6S47KozoKBezC2: {
          nick: 'cowmaster',
          operatorId: 'THNDR',
          position: 41,
          rank: 41,
          value: 796,
        },
        uwDvADYKOLNmQJ9WX83SXUmjA0i1: {
          nick: 'Lavalava',
          operatorId: 'THNDR',
          position: 90,
          rank: 90,
          value: 274.5,
        },
        vfrqXxPqY9WZPSbem0Clz8vyRTn1: {
          nick: 'passie',
          operatorId: 'THNDR',
          position: 34,
          rank: 34,
          value: 1048,
        },
        wVsUPJzFsAYPGDMfyVFIXUJLeap1: {
          nick: 'jaflowers515',
          operatorId: 'THNDR',
          position: 97,
          rank: 97,
          value: 246.20000000000002,
        },
        wwACEIvG3LWbirz1Axs5XM0RDyh2: {
          nick: 'DemonaZA',
          operatorId: 'THNDR',
          position: 91,
          rank: 91,
          value: 268,
        },
        xCuf2JIaZMga2lKEiIsqp3VfFoP2: {
          nick: 'wowza',
          operatorId: 'THNDR',
          position: 26,
          rank: 26,
          value: 1332.5,
        },
        yDAwydl9hKhXwGRnNGndzGKc8Rw1: {
          nick: 'Bulldogge',
          operatorId: 'THNDR',
          position: 100,
          rank: 100,
          value: 240,
        },
      },
    },
  },
};
